/* Copyright (c) 2020-present CloudIO Inc */

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */

import { CustomComponentItem } from '@cloudio-saas/custom-types';
import { ActionAbortItem } from '../actions/ActionAbort/ActionAbort';
import ActionAbortManager from '../actions/ActionAbort/ActionAbortManager';
import { ActionAddSmartSearchFiltersFromAggregateItem } from '../actions/ActionAddSmartSearchFiltersFromAggregate/ActionAddSmartSearchFiltersFromAggregate';
import ActionAddSmartSearchFiltersFromAggregateManager from '../actions/ActionAddSmartSearchFiltersFromAggregate/ActionAddSmartSearchFiltersFromAggregateManager';
import { ActionApproveWorkflowItem } from '../actions/ActionApproveWorkflow/ActionApproveWorkflow';
import ActionApproveWorkflowManager from '../actions/ActionApproveWorkflow/ActionApproveWorkflowManager';
import { ActionBatchItem } from '../actions/ActionBatch/ActionBatch';
import ActionBatchManager from '../actions/ActionBatch/ActionBatchManager';
import { ActionBrowserRefreshItem } from '../actions/ActionBrowserRefresh/ActionBrowserRefresh';
import ActionBrowserRefreshManager from '../actions/ActionBrowserRefresh/ActionBrowserRefreshManager';
import { ActionClearItem } from '../actions/ActionClear/ActionClear';
import ActionClearManager from '../actions/ActionClear/ActionClearManager';
import { ActionClearFiltersItem } from '../actions/ActionClearFilters/ActionClearFilters';
import ActionClearFiltersManager from '../actions/ActionClearFilters/ActionClearFiltersManager';
import { ActionClearStoreCacheItem } from '../actions/ActionClearStoreCache/ActionClearStoreCache';
import ActionClearStoreCacheManager from '../actions/ActionClearStoreCache/ActionClearStoreCacheManager';
import { ActionCloseDrawerItem } from '../actions/ActionCloseDrawer/ActionCloseDrawer';
import ActionCloseDrawerManager from '../actions/ActionCloseDrawer/ActionCloseDrawerManager';
import { ActionClosePopoverItem } from '../actions/ActionClosePopover/ActionClosePopover';
import ActionClosePopoverManager from '../actions/ActionClosePopover/ActionClosePopoverManager';
import { ActionClosePopupItem } from '../actions/ActionClosePopup/ActionClosePopup';
import ActionClosePopupManager from '../actions/ActionClosePopup/ActionClosePopupManager';
import { ActionCopyFilterAttributeItem } from '../actions/ActionCopyFilterAttribute/ActionCopyFilterAttribute';
import ActionCopyFilterAttributeManager from '../actions/ActionCopyFilterAttribute/ActionCopyFilterAttributeManager';
import { ActionCopyFiltersItem } from '../actions/ActionCopyFilters/ActionCopyFilters';
import ActionCopyFiltersManager from '../actions/ActionCopyFilters/ActionCopyFiltersManager';
import { ActionCopyRecordItem } from '../actions/ActionCopyRecord/ActionCopyRecord';
import ActionCopyRecordManager from '../actions/ActionCopyRecord/ActionCopyRecordManager';
import { ActionCopySmartSearchFiltersItem } from '../actions/ActionCopySmartSearchFilters/ActionCopySmartSearchFilters';
import ActionCopySmartSearchFiltersManager from '../actions/ActionCopySmartSearchFilters/ActionCopySmartSearchFiltersManager';
import { ActionCopyToClipboardItem } from '../actions/ActionCopyToClipboard/ActionCopyToClipboard';
import ActionCopyToClipboardManager from '../actions/ActionCopyToClipboard/ActionCopyToClipboardManager';
import { ActionCreateItem } from '../actions/ActionCreate/ActionCreate';
import ActionCreateManager from '../actions/ActionCreate/ActionCreateManager';
import { ActionDeleteCurrentRecordItem } from '../actions/ActionDeleteCurrentRecord/ActionDeleteCurrentRecord';
import ActionDeleteCurrentRecordManager from '../actions/ActionDeleteCurrentRecord/ActionDeleteCurrentRecordManager';
import { ActionDeleteSelectedRecordsItem } from '../actions/ActionDeleteSelectedRecords/ActionDeleteSelectedRecords';
import ActionDeleteSelectedRecordsManager from '../actions/ActionDeleteSelectedRecords/ActionDeleteSelectedRecordsManager';
import { ActionDeselectAllItem } from '../actions/ActionDeselectAll/ActionDeselectAll';
import ActionDeselectAllManager from '../actions/ActionDeselectAll/ActionDeselectAllManager';
import { ActionDeselectBreadcrumbNavigationLeafNodeItem } from '../actions/ActionDeselectBreadcrumbNavigationLeafNode/ActionDeselectBreadcrumbNavigationLeafNode';
import ActionDeselectBreadcrumbNavigationLeafNodeManager from '../actions/ActionDeselectBreadcrumbNavigationLeafNode/ActionDeselectBreadcrumbNavigationLeafNodeManager';
import { ActionDeselectRecordItem } from '../actions/ActionDeselectRecord/ActionDeselectRecord';
import ActionDeselectRecordManager from '../actions/ActionDeselectRecord/ActionDeselectRecordManager';
import { ActionDownloadAttachmentItem } from '../actions/ActionDownloadAttachment/ActionDownloadAttachment';
import ActionDownloadAttachmentManager from '../actions/ActionDownloadAttachment/ActionDownloadAttachmentManager';
import { ActionDownloadChartDataItem } from '../actions/ActionDownloadChartData/ActionDownloadChartData';
import ActionDownloadChartDataManager from '../actions/ActionDownloadChartData/ActionDownloadChartDataManager';
import { ActionDownloadChartImageItem } from '../actions/ActionDownloadChartImage/ActionDownloadChartImage';
import ActionDownloadChartImageManager from '../actions/ActionDownloadChartImage/ActionDownloadChartImageManager';
import { ActionDuplicateRecordItem } from '../actions/ActionDuplicateRecord/ActionDuplicateRecord';
import ActionDuplicateRecordManager from '../actions/ActionDuplicateRecord/ActionDuplicateRecordManager';
import { ActionExportDataItem } from '../actions/ActionExportData/ActionExportData';
import ActionExportDataManager from '../actions/ActionExportData/ActionExportDataManager';
import { ActionFocusItem } from '../actions/ActionFocus/ActionFocus';
import ActionFocusManager from '../actions/ActionFocus/ActionFocusManager';
import { ActionForceUpdateItem } from '../actions/ActionForceUpdate/ActionForceUpdate';
import ActionForceUpdateManager from '../actions/ActionForceUpdate/ActionForceUpdateManager';
import { ActionGoBackItem } from '../actions/ActionGoBack/ActionGoBack';
import ActionGoBackManager from '../actions/ActionGoBack/ActionGoBackManager';
import { ActionGoToAddDataSourceItem } from '../actions/ActionGoToAddDataSource/ActionGoToAddDataSource';
import ActionGoToAddDataSourceManager from '../actions/ActionGoToAddDataSource/ActionGoToAddDataSourceManager';
import { ActionGoToAddFunctionItem } from '../actions/ActionGoToAddFunction/ActionGoToAddFunction';
import ActionGoToAddFunctionManager from '../actions/ActionGoToAddFunction/ActionGoToAddFunctionManager';
import { ActionGoToAddPageItem } from '../actions/ActionGoToAddPage/ActionGoToAddPage';
import ActionGoToAddPageManager from '../actions/ActionGoToAddPage/ActionGoToAddPageManager';
import { ActionGoToAddRoleItem } from '../actions/ActionGoToAddRole/ActionGoToAddRole';
import ActionGoToAddRoleManager from '../actions/ActionGoToAddRole/ActionGoToAddRoleManager';
import { ActionGoToAddUserItem } from '../actions/ActionGoToAddUser/ActionGoToAddUser';
import ActionGoToAddUserManager from '../actions/ActionGoToAddUser/ActionGoToAddUserManager';
import { ActionGoToAddWorkflowItem } from '../actions/ActionGoToAddWorkflow/ActionGoToAddWorkflow';
import ActionGoToAddWorkflowManager from '../actions/ActionGoToAddWorkflow/ActionGoToAddWorkflowManager';
import { ActionGoToPageItem } from '../actions/ActionGoToPage/ActionGoToPage';
import ActionGoToPageManager from '../actions/ActionGoToPage/ActionGoToPageManager';
import {
  ActionGoToFirstRecordItem,
  ActionGoToLastRecordItem,
  ActionGoToNextRecordItem,
  ActionGoToPreviousRecordItem,
} from '../actions/ActionGoToRecord/ActionGoToRecord';
import ActionGoToRecordManager from '../actions/ActionGoToRecord/ActionGoToRecordManager';
import { ActionGoToViewDataSourcesItem } from '../actions/ActionGoToViewDataSources/ActionGoToViewDataSources';
import ActionGoToViewDataSourcesManager from '../actions/ActionGoToViewDataSources/ActionGoToViewDataSourcesManager';
import { ActionGoToViewFunctionsItem } from '../actions/ActionGoToViewFunctions/ActionGoToViewFunctions';
import ActionGoToViewFunctionsManager from '../actions/ActionGoToViewFunctions/ActionGoToViewFunctionsManager';
import { ActionGoToViewPagesItem } from '../actions/ActionGoToViewPages/ActionGoToViewPages';
import ActionGoToViewPagesManager from '../actions/ActionGoToViewPages/ActionGoToViewPagesManager';
import { ActionGoToViewRolesItem } from '../actions/ActionGoToViewRoles/ActionGoToViewRoles';
import ActionGoToViewRolesManager from '../actions/ActionGoToViewRoles/ActionGoToViewRolesManager';
import { ActionGoToViewUsersItem } from '../actions/ActionGoToViewUsers/ActionGoToViewUsers';
import ActionGoToViewUsersManager from '../actions/ActionGoToViewUsers/ActionGoToViewUsersManager';
import { ActionGoToViewWorkflowsItem } from '../actions/ActionGoToViewWorkflows/ActionGoToViewWorkflows';
import ActionGoToViewWorkflowsManager from '../actions/ActionGoToViewWorkflows/ActionGoToViewWorkflowsManager';
import { ActionHideItem } from '../actions/ActionHide/ActionHide';
import ActionHideManager from '../actions/ActionHide/ActionHideManager';
import { ActionImportItem } from '../actions/ActionImport/ActionImport';
import ActionImportManager from '../actions/ActionImport/ActionImportManager';
import { ActionInvokeCloudFunctionItem } from '../actions/ActionInvokeCloudFunction/ActionInvokeCloudFunction';
import ActionInvokeCloudFunctionManager from '../actions/ActionInvokeCloudFunction/ActionInvokeCloudFunctionManager';
import { ActionInvokeControllerFunctionItem } from '../actions/ActionInvokeControllerFunction/ActionInvokeControllerFunction';
import ActionInvokeControllerFunctionManager from '../actions/ActionInvokeControllerFunction/ActionInvokeControllerFunctionManager';
import { ActionInvokeTriggerItem } from '../actions/ActionInvokeTrigger/ActionInvokeTrigger';
import ActionInvokeTriggerManager from '../actions/ActionInvokeTrigger/ActionInvokeTriggerManager';
import { ActionInvokeUIScriptItem } from '../actions/ActionInvokeUIScript/ActionInvokeUIScript';
import ActionInvokeUIScriptManager from '../actions/ActionInvokeUIScript/ActionInvokeUIScriptManager';
import { ActionLoadDataItem } from '../actions/ActionLoadData/ActionLoadData';
import ActionLoadDataManager from '../actions/ActionLoadData/ActionLoadDataManager';
import { ActionLogToConsoleItem } from '../actions/ActionLogToConsole/ActionLogToConsole';
import ActionLogToConsoleManager from '../actions/ActionLogToConsole/ActionLogToConsoleManager';
import { ActionLoopDeselectItem } from '../actions/ActionLoopDeselect/ActionLoopDeselect';
import ActionLoopDeselectManager from '../actions/ActionLoopDeselect/ActionLoopDeselectManager';
import { ActionLoopRecordsItem } from '../actions/ActionLoopRecords/ActionLoopRecords';
import ActionLoopRecordsManager from '../actions/ActionLoopRecords/ActionLoopRecordsManager';
import { ActionLoopSelectItem } from '../actions/ActionLoopSelect/ActionLoopSelect';
import ActionLoopSelectManager from '../actions/ActionLoopSelect/ActionLoopSelectManager';
import { ActionMatchRecordItem } from '../actions/ActionMatchRecord/ActionMatchRecord';
import ActionMatchRecordManager from '../actions/ActionMatchRecord/ActionMatchRecordManager';
import { ActionNavigateToPageLinkItem } from '../actions/ActionNavigateToPageLink/ActionNavigateToPageLink';
import ActionNavigateToPageLinkManager from '../actions/ActionNavigateToPageLink/ActionNavigateToPageLinkManager';
import { ActionNotifyRolesItem } from '../actions/ActionNotifyRoles/ActionNotifyRoles';
import ActionNotifyRolesManager from '../actions/ActionNotifyRoles/ActionNotifyRolesManager';
import { ActionNotifyUsersItem } from '../actions/ActionNotifyUsers/ActionNotifyUsers';
import ActionNotifyUsersManager from '../actions/ActionNotifyUsers/ActionNotifyUsersManager';
import { ActionOnCancelItem } from '../actions/ActionOnCancel/ActionOnCancel';
import ActionOnCancelManager from '../actions/ActionOnCancel/ActionOnCancelManager';
import { ActionOnConfirmItem } from '../actions/ActionOnConfirm/ActionOnConfirm';
import ActionOnConfirmManager from '../actions/ActionOnConfirm/ActionOnConfirmManager';
import { ActionOnMatchFoundItem } from '../actions/ActionOnMatchFound/ActionOnMatchFound';
import ActionOnMatchFoundManager from '../actions/ActionOnMatchFound/ActionOnMatchFoundManager';
import { ActionOnMatchNotFoundItem } from '../actions/ActionOnMatchNotFound/ActionOnMatchNotFound';
import ActionOnMatchNotFoundManager from '../actions/ActionOnMatchNotFound/ActionOnMatchNotFoundManager';
import { ActionOnResponseItem } from '../actions/ActionOnResponse/ActionOnResponse';
import ActionOnResponseManager from '../actions/ActionOnResponse/ActionOnResponseManager';
import { ActionOnTimeoutItem } from '../actions/ActionOnTimeout/ActionOnTimeout';
import ActionOnTimeoutManager from '../actions/ActionOnTimeout/ActionOnTimeoutManager';
import { ActionOpenAttachmentRevisionsItem } from '../actions/ActionOpenAttachmentRevisions/ActionOpenAttachmentRevisions';
import ActionOpenAttachmentRevisionsManager from '../actions/ActionOpenAttachmentRevisions/ActionOpenAttachmentRevisionsManager';
import { ActionOpenCommentsItem } from '../actions/ActionOpenComments/ActionOpenComments';
import ActionOpenCommentsManager from '../actions/ActionOpenComments/ActionOpenCommentsManager';
import { ActionOpenDrawerItem } from '../actions/ActionOpenDrawer/ActionOpenDrawer';
import ActionOpenDrawerManager from '../actions/ActionOpenDrawer/ActionOpenDrawerManager';
import { ActionOpenPopoverItem } from '../actions/ActionOpenPopover/ActionOpenPopover';
import ActionOpenPopoverManager from '../actions/ActionOpenPopover/ActionOpenPopoverManager';
import { ActionOpenPopupItem } from '../actions/ActionOpenPopup/ActionOpenPopup';
import ActionOpenPopupManager from '../actions/ActionOpenPopup/ActionOpenPopupManager';
import { ActionOpenSignaturePadItem } from '../actions/ActionOpenSignaturePad/ActionOpenSignaturePad';
import ActionOpenSignaturePadManager from '../actions/ActionOpenSignaturePad/ActionOpenSignaturePadManager';
import { ActionOpenURLItem } from '../actions/ActionOpenURL/ActionOpenURL';
import ActionOpenURLManager from '../actions/ActionOpenURL/ActionOpenURLManager';
import { ActionOpenUserProfileItem } from '../actions/ActionOpenUserProfile/ActionOpenUserProfile';
import ActionOpenUserProfileManager from '../actions/ActionOpenUserProfile/ActionOpenUserProfileManager';
import { ActionParallelItem } from '../actions/ActionParallel/ActionParallel';
import ActionParallelManager from '../actions/ActionParallel/ActionParallelManager';
import { ActionPublishEventItem } from '../actions/ActionPublishEvent/ActionPublishEvent';
import ActionPublishEventManager from '../actions/ActionPublishEvent/ActionPublishEventManager';
import { ActionQueryItem } from '../actions/ActionQuery/ActionQuery';
import ActionQueryManager from '../actions/ActionQuery/ActionQueryManager';
import { ActionQueryChartItem } from '../actions/ActionQueryChart/ActionQueryChart';
import ActionQueryChartManager from '../actions/ActionQueryChart/ActionQueryChartManager';
import { ActionQuerySelectItem } from '../actions/ActionQuerySelect/ActionQuerySelect';
import ActionQuerySelectManager from '../actions/ActionQuerySelect/ActionQuerySelectManager';
import { ActionRedrawCanvasGridItem } from '../actions/ActionRedrawCanvasGrid/ActionRedrawCanvasGrid';
import ActionRedrawCanvasGridManager from '../actions/ActionRedrawCanvasGrid/ActionRedrawCanvasGridManager';
import { ActionReduceItem } from '../actions/ActionReduce/ActionReduce';
import ActionReduceManager from '../actions/ActionReduce/ActionReduceManager';
import { ActionRefreshItem } from '../actions/ActionRefresh/ActionRefresh';
import ActionRefreshManager from '../actions/ActionRefresh/ActionRefreshManager';
import { ActionRejectWorkflowItem } from '../actions/ActionRejectWorkflow/ActionRejectWorkflow';
import ActionRejectWorkflowManager from '../actions/ActionRejectWorkflow/ActionRejectWorkflowManager';
import { ActionRemoveURLParamItem } from '../actions/ActionRemoveURLParam/ActionRemoveURLParam';
import ActionRemoveURLParamManager from '../actions/ActionRemoveURLParam/ActionRemoveURLParamManager';
import { ActionResetItem } from '../actions/ActionReset/ActionReset';
import ActionResetManager from '../actions/ActionReset/ActionResetManager';
import { ActionResetCurrentRecordItem } from '../actions/ActionResetCurrentRecord/ActionResetCurrentRecord';
import ActionResetCurrentRecordManager from '../actions/ActionResetCurrentRecord/ActionResetCurrentRecordManager';
import { ActionRunJSItem } from '../actions/ActionRunJS/ActionRunJS';
import ActionRunJSManager from '../actions/ActionRunJS/ActionRunJSManager';
import { ActionSaveItem } from '../actions/ActionSave/ActionSave';
import ActionSaveManager from '../actions/ActionSave/ActionSaveManager';
import { ActionSaveTransactionItem } from '../actions/ActionSaveTransaction/ActionSaveTransaction';
import ActionSaveTransactionManager from '../actions/ActionSaveTransaction/ActionSaveTransactionManager';
import { ActionSelectAllItem } from '../actions/ActionSelectAll/ActionSelectAll';
import ActionSelectAllManager from '../actions/ActionSelectAll/ActionSelectAllManager';
import { ActionSelectBreadcrumbNavigationLeafNodeItem } from '../actions/ActionSelectBreadcrumbNavigationLeafNode/ActionSelectBreadcrumbNavigationLeafNode';
import ActionSelectBreadcrumbNavigationLeafNodeManager from '../actions/ActionSelectBreadcrumbNavigationLeafNode/ActionSelectBreadcrumbNavigationLeafNodeManager';
import { ActionSelectRecordItem } from '../actions/ActionSelectRecord/ActionSelectRecord';
import ActionSelectRecordManager from '../actions/ActionSelectRecord/ActionSelectRecordManager';
import { ActionSendEmailItem } from '../actions/ActionSendEmail/ActionSendEmail';
import ActionSendEmailManager from '../actions/ActionSendEmail/ActionSendEmailManager';
import { ActionSetItem } from '../actions/ActionSet/ActionSet';
import ActionSetManager from '../actions/ActionSet/ActionSetManager';
import { ActionSetAggregateAttributeItem } from '../actions/ActionSetAggregateAttribute/ActionSetAggregateAttribute';
import ActionSetAggregateAttributeManager from '../actions/ActionSetAggregateAttribute/ActionSetAggregateAttributeManager';
import { ActionSetAttributeErrorItem } from '../actions/ActionSetAttributeError/ActionSetAttributeError';
import ActionSetAttributeErrorManager from '../actions/ActionSetAttributeError/ActionSetAttributeErrorManager';
import { ActionSetBIFilterParamItem } from '../actions/ActionSetBIFilterParam/ActionSetBIFilterParam';
import ActionSetBIFilterParamManager from '../actions/ActionSetBIFilterParam/ActionSetBIFilterParamManager';
import { ActionSetCurrentRecordItem } from '../actions/ActionSetCurrentRecord/ActionSetCurrentRecord';
import ActionSetCurrentRecordManager from '../actions/ActionSetCurrentRecord/ActionSetCurrentRecordManager';
import { ActionSetDataItem } from '../actions/ActionSetData/ActionSetData';
import ActionSetDataManager from '../actions/ActionSetData/ActionSetDataManager';
import { ActionSetDefaultFiltersItem } from '../actions/ActionSetDefaultFilters/ActionSetDefaultFilters';
import ActionSetDefaultFiltersManager from '../actions/ActionSetDefaultFilters/ActionSetDefaultFiltersManager';
import { ActionSetDistinctItem } from '../actions/ActionSetDistinct/ActionSetDistinct';
import ActionSetDistinctManager from '../actions/ActionSetDistinct/ActionSetDistinctManager';
import { ActionSetFilterCombinerItem } from '../actions/ActionSetFilterCombiner/ActionSetFilterCombiner';
import ActionSetFilterCombinerManager from '../actions/ActionSetFilterCombiner/ActionSetFilterCombinerManager';
import { ActionSetGroupByAttributeItem } from '../actions/ActionSetGroupByAttribute/ActionSetGroupByAttribute';
import ActionSetGroupByAttributeManager from '../actions/ActionSetGroupByAttribute/ActionSetGroupByAttributeManager';
import { ActionSetParamItem } from '../actions/ActionSetParam/ActionSetParam';
import ActionSetParamManager from '../actions/ActionSetParam/ActionSetParamManager';
import { ActionSetProjectionItem } from '../actions/ActionSetProjection/ActionSetProjection';
import ActionSetProjectionManager from '../actions/ActionSetProjection/ActionSetProjectionManager';
import { ActionSetQueryFilterItem } from '../actions/ActionSetQueryFilter/ActionSetQueryFilter';
import ActionSetQueryFilterManager from '../actions/ActionSetQueryFilter/ActionSetQueryFilterManager';
import { ActionSetSimpleQueryFilterItem } from '../actions/ActionSetSimpleQueryFilter/ActionSetSimpleQueryFilter';
import ActionSetSimpleQueryFilterManager from '../actions/ActionSetSimpleQueryFilter/ActionSetSimpleQueryFilterManager';
import { ActionSetSortItem } from '../actions/ActionSetSort/ActionSetSort';
import ActionSetSortManager from '../actions/ActionSetSort/ActionSetSortManager';
import { ActionShareURLItem } from '../actions/ActionShareURL/ActionShareURL';
import ActionShareURLManager from '../actions/ActionShareURL/ActionShareURLManager';
import { ActionShowItem } from '../actions/ActionShow/ActionShow';
import ActionShowManager from '../actions/ActionShow/ActionShowManager';
import { ActionShowAuditItem } from '../actions/ActionShowAudit/ActionShowAudit';
import ActionShowAuditManager from '../actions/ActionShowAudit/ActionShowAuditManager';
import { ActionShowMessageItem } from '../actions/ActionShowMessage/ActionShowMessage';
import ActionShowMessageManager from '../actions/ActionShowMessage/ActionShowMessageManager';
import { ActionSignOutItem } from '../actions/ActionSignOut/ActionSignOut';
import ActionSignOutManager from '../actions/ActionSignOut/ActionSignOutManager';
import { ActionSleepItem } from '../actions/ActionSleep/ActionSleep';
import ActionSleepManager from '../actions/ActionSleep/ActionSleepManager';
import { ActionSwitchItem } from '../actions/ActionSwitch/ActionSwitch';
import ActionSwitchManager from '../actions/ActionSwitch/ActionSwitchManager';
import { ActionSwitchCaseItem } from '../actions/ActionSwitchCase/ActionSwitchCase';
import ActionSwitchCaseManager from '../actions/ActionSwitchCase/ActionSwitchCaseManager';
import { ActionURLParamItem } from '../actions/ActionURLParam/ActionURLParam';
import ActionURLParamManager from '../actions/ActionURLParam/ActionURLParamManager';
import { ActionUpdatePropItem } from '../actions/ActionUpdateProp/ActionUpdateProp';
import ActionUpdatePropManager from '../actions/ActionUpdateProp/ActionUpdatePropManager';
import { ActionUpdateRecordItem } from '../actions/ActionUpdateRecord/ActionUpdateRecord';
import ActionUpdateRecordManager from '../actions/ActionUpdateRecord/ActionUpdateRecordManager';
import { ActionUserConfirmationItem } from '../actions/ActionUserConfirmation/ActionUserConfirmation';
import ActionUserConfirmationManager from '../actions/ActionUserConfirmation/ActionUserConfirmationManager';
import { ActionWaitForItem } from '../actions/ActionWaitFor/ActionWaitFor';
import ActionWaitForManager from '../actions/ActionWaitFor/ActionWaitForManager';
import { AccordionItem } from '../components/Accordion/Accordion';
import AccordionManager from '../components/Accordion/AccordionManager';
import { ActionButtonItem } from '../components/ActionButton/ActionButton';
import ActionButtonManager from '../components/ActionButton/ActionButtonManager';
import { ActiveUsersItem } from '../components/ActiveUsers/ActiveUsers';
import ActiveUsersManager from '../components/ActiveUsers/ActiveUsersManager';
import { AlertItem } from '../components/Alert/Alert';
import AlertManager from '../components/Alert/AlertManager';
import { AsyncSelectItem } from '../components/AsyncSelect/AsyncSelect';
import AsyncSelectManager from '../components/AsyncSelect/AsyncSelectManager';
import { AttachmentFieldItem } from '../components/AttachmentField/AttachmentField';
import AttachmentFieldManager from '../components/AttachmentField/AttachmentFieldManager';
import { AttachmentRevisionsItem } from '../components/AttachmentRevisions/AttachmentRevisions';
import AttachmentRevisionsManager from '../components/AttachmentRevisions/AttachmentRevisionsManager';
import { AutoSizerItem } from '../components/AutoSizer/AutoSizer';
import AutoSizerManager from '../components/AutoSizer/AutoSizerManager';
import { AvatarItem } from '../components/Avatar/Avatar';
import AvatarManager from '../components/Avatar/AvatarManager';
import { AvatarListItem } from '../components/AvatarList/AvatarList';
import AvatarListManager from '../components/AvatarList/AvatarListManager';
import { BadgeItem } from '../components/Badge/Badge';
import BadgeManager from '../components/Badge/BadgeManager';
import { BingMapItem } from '../components/BingMap/BingMap';
import BingMapManager from '../components/BingMap/BingMapManager';
import { InfoBoxItem } from '../components/BingMap/InfoBox';
import InfoBoxManager from '../components/BingMap/InfoBoxManager';
import { BingMapNavigatorItem } from '../components/BingMapNavigator/BingMapNavigator';
import BingMapNavigatorManager from '../components/BingMapNavigator/BingMapNavigatorManager';
import { BoxItem } from '../components/Box/Box';
import BoxManager from '../components/Box/BoxManager';
import { BoxContainerItem } from '../components/BoxContainer/BoxContainer';
import BoxContainerManager from '../components/BoxContainer/BoxContainerManager';
import { BoxListItem } from '../components/BoxList/BoxList';
import BoxListManager from '../components/BoxList/BoxListManager';
import { BreadcrumbItem } from '../components/Breadcrumb/Breadcrumb';
import BreadcrumbManager from '../components/Breadcrumb/BreadcrumbManager';
import { BreadcrumbItemItem } from '../components/BreadcrumbItem/BreadcrumbItem';
import BreadcrumbItemManager from '../components/BreadcrumbItem/BreadcrumbItemManager';
import { BreadcrumbNavigationItem } from '../components/BreadcrumbNavigation/BreadcrumbNavigation';
import BreadcrumbNavigationManager from '../components/BreadcrumbNavigation/BreadcrumbNavigationManager';
import { ButtonItem } from '../components/Button/Button';
import ButtonManager from '../components/Button/ButtonManager';
import { ButtonDropdownItem } from '../components/ButtonDropdown/ButtonDropdown';
import ButtonDropdownManager from '../components/ButtonDropdown/ButtonDropdownManager';
import { ButtonDropdownChildItem } from '../components/ButtonDropdownChild/ButtonDropdownChild';
import ButtonDropdownChildManager from '../components/ButtonDropdownChild/ButtonDropdownChildManager';
import { ButtonGroupItem } from '../components/ButtonGroup/ButtonGroup';
import ButtonGroupManager from '../components/ButtonGroup/ButtonGroupManager';
import { CalendarItem } from '../components/Calendar/Calendar';
import CalendarManager from '../components/Calendar/CalendarManager';
import { CalendarHeatmapItem } from '../components/CalendarHeatmap/CalendarHeatmap';
import CalendarHeatmapManager from '../components/CalendarHeatmap/CalendarHeatmapManager';
import { CanvasGridItem } from '../components/CanvasGrid/CanvasGrid';
import CanvasGridManager from '../components/CanvasGrid/CanvasGridManager';
import { CardItem } from '../components/Card/Card';
import { CardActionsItem } from '../components/Card/CardActions/CardActions';
import CardActionsManager from '../components/Card/CardActions/CardActionsManager';
import { CardContentItem } from '../components/Card/CardContent/CardContent';
import CardContentManager from '../components/Card/CardContent/CardContentManager';
import { CardHeaderItem } from '../components/Card/CardHeader/CardHeader';
import CardHeaderManager from '../components/Card/CardHeader/CardHeaderManager';
import CardManager from '../components/Card/CardManager';
import { ChartJSTooltipItem } from '../components/ChartJSTooltip/ChartJSTooltip';
import ChartJSTooltipManager from '../components/ChartJSTooltip/ChartJSTooltipManager';
import { ChartJSTreemapItem } from '../components/ChartJSTreemap/ChartJSTreemap';
import ChartJSTreemapManager from '../components/ChartJSTreemap/ChartJSTreemapManager';
import { ChartjsItem } from '../components/Chartjs/Chartjs';
import ChartjsManager from '../components/Chartjs/ChartjsManager';
import { CheckboxItem } from '../components/Checkbox/Checkbox';
import CheckboxManager from '../components/Checkbox/CheckboxManager';
import { CheckboxSearchFieldItem } from '../components/CheckboxSearchField/CheckboxSearchField';
import CheckboxSearchFieldManager from '../components/CheckboxSearchField/CheckboxSearchFieldManager';
import { ChipItem } from '../components/Chip/Chip';
import ChipManager from '../components/Chip/ChipManager';
import { ChipsItem } from '../components/Chips/Chips';
import ChipsManager from '../components/Chips/ChipsManager';
import { ClientSideExcelUploadItem } from '../components/ClientSideExcelUpload/ClientSideExcelUpload';
import ClientSideExcelUploadManager from '../components/ClientSideExcelUpload/ClientSideExcelUploadManager';
import { ClipboardItem } from '../components/Clipboard/Clipboard';
import ClipboardManager from '../components/Clipboard/ClipboardManager';
import { CloudDataStoreItem } from '../components/CloudDataStore/CloudDataStore';
import CloudDataStoreManager from '../components/CloudDataStore/CloudDataStoreManager';
import { CodeItem } from '../components/Code/Code';
import CodeManager from '../components/Code/CodeManager';
import { CollectionListItem } from '../components/CollectionList/CollectionList';
import CollectionListManager from '../components/CollectionList/CollectionListManager';
import { ColumnPanelItem } from '../components/ColumnPanel/ColumnPanel';
import ColumnPanelManager from '../components/ColumnPanel/ColumnPanelManager';
import { CombinationChartItem } from '../components/CombinationChart/CombinationChart';
import CombinationChartManager from '../components/CombinationChart/CombinationChartManager';
import { CommentActionMenuItemsItem } from '../components/CommentActionMenuItems/CommentActionMenuItems';
import CommentActionMenuItemsManager from '../components/CommentActionMenuItems/CommentActionMenuItemsManager';
import { CommentsItem } from '../components/Comments/Comments';
import CommentsManager from '../components/Comments/CommentsManager';
import { CommentsPanelItem } from '../components/CommentsPanel/CommentsPanel';
import CommentsPanelManager from '../components/CommentsPanel/CommentsPanelManager';
import { ControllerComponentItem } from '../components/ControllerComponent/ControllerComponent';
import ControllerComponentManager from '../components/ControllerComponent/ControllerComponentManager';
import CustomTestManager from '../components/CustomTest/CustomTestManager';
import { D3ChartItem } from '../components/D3Chart/D3Chart';
import D3ChartManager from '../components/D3Chart/D3ChartManager';
import { DarkModeToggleItem } from '../components/DarkModeToggle/DarkModeToggle';
import DarkModeToggleManager from '../components/DarkModeToggle/DarkModeToggleManager';
import { ColumnFooterItem } from '../components/DataGrid/ColumnFooter/ColumnFooter';
import ColumnFooterManager from '../components/DataGrid/ColumnFooter/ColumnFooterManager';
import { DataGridItem } from '../components/DataGrid/DataGrid';
import DataGridManager from '../components/DataGrid/DataGridManager';
import { ActionIconsColumnItem } from '../components/DataGrid/columns/ActionIconsColumn/ActionIconsColumn';
import ActionIconsColumnManager from '../components/DataGrid/columns/ActionIconsColumn/ActionIconsColumnManager';
import { AsyncSelectColumnItem } from '../components/DataGrid/columns/AsyncSelectColumn/AsyncSelectColumn';
import AsyncSelectColumnManager from '../components/DataGrid/columns/AsyncSelectColumn/AsyncSelectColumnManager';
import { AttachmentColumnItem } from '../components/DataGrid/columns/AttachmentColumn/AttachmentColumn';
import AttachmentColumnManager from '../components/DataGrid/columns/AttachmentColumn/AttachmentColumnManager';
import { ButtonColumnItem } from '../components/DataGrid/columns/ButtonColumn/ButtonColumn';
import ButtonColumnManager from '../components/DataGrid/columns/ButtonColumn/ButtonColumnManager';
import { CheckboxColumnItem } from '../components/DataGrid/columns/CheckboxColumn/CheckboxColumn';
import CheckboxColumnManager from '../components/DataGrid/columns/CheckboxColumn/CheckboxColumnManager';
import { DateColumnItem } from '../components/DataGrid/columns/DateColumn/DateColumn';
import DateColumnManager from '../components/DataGrid/columns/DateColumn/DateColumnManager';
import { DivColumnItem } from '../components/DataGrid/columns/DivColumn/DivColumn';
import DivColumnManager from '../components/DataGrid/columns/DivColumn/DivColumnManager';
import { FormulaNumberColumnItem } from '../components/DataGrid/columns/FormulaNumberColumn/FormulaNumberColumn';
import FormulaNumberColumnManager from '../components/DataGrid/columns/FormulaNumberColumn/FormulaNumberColumnManager';
import { FormulaStringColumnItem } from '../components/DataGrid/columns/FormulaStringColumn/FormulaStringColumn';
import FormulaStringColumnManager from '../components/DataGrid/columns/FormulaStringColumn/FormulaStringColumnManager';
import { IconColumnItem } from '../components/DataGrid/columns/IconColumn/IconColumn';
import IconColumnManager from '../components/DataGrid/columns/IconColumn/IconColumnManager';
import { ImageColumnItem } from '../components/DataGrid/columns/ImageColumn/ImageColumn';
import ImageColumnManager from '../components/DataGrid/columns/ImageColumn/ImageColumnManager';
import { LOVColumnItem } from '../components/DataGrid/columns/LOVColumn/LOVColumn';
import LOVColumnManager from '../components/DataGrid/columns/LOVColumn/LOVColumnManager';
import { LookupSelectColumnItem } from '../components/DataGrid/columns/LookupSelectColumn/LookupSelectColumn';
import LookupSelectColumnManager from '../components/DataGrid/columns/LookupSelectColumn/LookupSelectColumnManager';
import { NumberColumnItem } from '../components/DataGrid/columns/NumberColumn/NumberColumn';
import NumberColumnManager from '../components/DataGrid/columns/NumberColumn/NumberColumnManager';
import { ProgressIndicatorColumnItem } from '../components/DataGrid/columns/ProgressIndicatorColumn/ProgressIndicatorColumn';
import ProgressIndicatorColumnManager from '../components/DataGrid/columns/ProgressIndicatorColumn/ProgressIndicatorColumnManager';
import { RowNumberColumnItem } from '../components/DataGrid/columns/RowNumberColumn/RowNumberColumn';
import RowNumberColumnManager from '../components/DataGrid/columns/RowNumberColumn/RowNumberColumnManager';
import { RowSelectionColumnItem } from '../components/DataGrid/columns/RowSelectionColumn/RowSelectionColumn';
import RowSelectionColumnManager from '../components/DataGrid/columns/RowSelectionColumn/RowSelectionColumnManager';
import { SelectColumnItem } from '../components/DataGrid/columns/SelectColumn/SelectColumn';
import SelectColumnManager from '../components/DataGrid/columns/SelectColumn/SelectColumnManager';
import { StarColumnItem } from '../components/DataGrid/columns/StarColumn/StarColumn';
import StarColumnManager from '../components/DataGrid/columns/StarColumn/StarColumnManager';
import { StringColumnItem } from '../components/DataGrid/columns/StringColumn/StringColumn';
import StringColumnManager from '../components/DataGrid/columns/StringColumn/StringColumnManager';
import { SwitchColumnItem } from '../components/DataGrid/columns/SwitchColumn/SwitchColumn';
import { SwitchColumnCaseItem } from '../components/DataGrid/columns/SwitchColumn/SwitchColumnCase';
import SwitchColumnCaseManager from '../components/DataGrid/columns/SwitchColumn/SwitchColumnCaseManager';
import SwitchColumnManager from '../components/DataGrid/columns/SwitchColumn/SwitchColumnManager';
import { TreeColumnItem } from '../components/DataGrid/columns/TreeColumn/TreeColumn';
import TreeColumnManager from '../components/DataGrid/columns/TreeColumn/TreeColumnManager';
import { UserPicColumnItem } from '../components/DataGrid/columns/UserPicColumn/UserPicColumn';
import UserPicColumnManager from '../components/DataGrid/columns/UserPicColumn/UserPicColumnManager';
import { DataListItem } from '../components/DataList/DataList';
import DataListManager from '../components/DataList/DataListManager';
import { DataStoreItem } from '../components/DataStore/DataStore';
import DataStoreManager from '../components/DataStore/DataStoreManager';
import { DataStoreReferenceItem } from '../components/DataStoreReference/DataStoreReference';
import DataStoreReferenceManager from '../components/DataStoreReference/DataStoreReferenceManager';
import { DateFieldItem } from '../components/DateField/DateField';
import DateFieldManager from '../components/DateField/DateFieldManager';
import { DateSearchFieldItem } from '../components/DateSearchField/DateSearchField';
import DateSearchFieldManager from '../components/DateSearchField/DateSearchFieldManager';
import { DiffCheckerItem } from '../components/DiffChecker/DiffChecker';
import DiffCheckerManager from '../components/DiffChecker/DiffCheckerManager';
import { DividerItem } from '../components/Divider/Divider';
import DividerManager from '../components/Divider/DividerManager';
import { DragSourceItem } from '../components/DragSource/DragSource';
import DragSourceManager from '../components/DragSource/DragSourceManager';
import { DragSourceBoxItem } from '../components/DragSourceBox/DragSourceBox';
import DragSourceBoxManager from '../components/DragSourceBox/DragSourceBoxManager';
import { DrawerItem } from '../components/Drawer/Drawer';
import DrawerManager from '../components/Drawer/DrawerManager';
import { DropTargetItem } from '../components/DropTarget/DropTarget';
import DropTargetManager from '../components/DropTarget/DropTargetManager';
import { DropTargetBoxItem } from '../components/DropTargetBox/DropTargetBox';
import DropTargetBoxManager from '../components/DropTargetBox/DropTargetBoxManager';
import { EmbedPageItem } from '../components/EmbedPage/EmbedPage';
import EmbedPageManager from '../components/EmbedPage/EmbedPageManager';
import { EmptySpacerItem } from '../components/EmptySpacer/EmptySpacer';
import EmptySpacerManager from '../components/EmptySpacer/EmptySpacerManager';
import { EndIconItem } from '../components/EndIcon/EndIcon';
import EndIconManager from '../components/EndIcon/EndIconManager';
import { EventSubscriptionItem } from '../components/EventSubscription/EventSubscription';
import EventSubscriptionManager from '../components/EventSubscription/EventSubscriptionManager';
import { ExcelViewerItem } from '../components/ExcelViewer/ExcelViewer';
import ExcelViewerManager from '../components/ExcelViewer/ExcelViewerManager';
import { ExpressionBuilderFieldItem } from '../components/ExpressionBuilderField/ExpressionBuilderField';
import ExpressionBuilderFieldManager from '../components/ExpressionBuilderField/ExpressionBuilderFieldManager';
import { ExpressionWatchListenerItem } from '../components/ExpressionWatchListener/ExpressionWatchListener';
import ExpressionWatchListenerManager from '../components/ExpressionWatchListener/ExpressionWatchListenerManager';
import { ExpressionWatcherItem } from '../components/ExpressionWatcher/ExpressionWatcher';
import ExpressionWatcherManager from '../components/ExpressionWatcher/ExpressionWatcherManager';
import { FABItem } from '../components/FAB/FAB';
import FABManager from '../components/FAB/FABManager';
import { FlexItemItem } from '../components/FlexItem/FlexItem';
import FlexItemManager from '../components/FlexItem/FlexItemManager';
import { FlexPanelItem } from '../components/FlexPanel/FlexPanel';
import FlexPanelManager from '../components/FlexPanel/FlexPanelManager';
import { FloatingPanelItem } from '../components/FloatingPanel/FloatingPanel';
import FloatingPanelManager from '../components/FloatingPanel/FloatingPanelManager';
import { FolderItem } from '../components/Folder/Folder';
import FolderManager from '../components/Folder/FolderManager';
import { FormItem } from '../components/Form/Form';
import FormManager from '../components/Form/FormManager';
import { FormSearchItem } from '../components/FormSearch/FormSearch';
import FormSearchManager from '../components/FormSearch/FormSearchManager';
import { FullScreenToggleItem } from '../components/FullScreenToggle/FullScreenToggle';
import FullScreenToggleManager from '../components/FullScreenToggle/FullScreenToggleManager';
import { FunctionEditorItem } from '../components/FunctionEditor/FunctionEditor';
import FunctionEditorManager from '../components/FunctionEditor/FunctionEditorManager';
import { GoogleMapItem } from '../components/GoogleMap/GoogleMap';
import GoogleMapManager from '../components/GoogleMap/GoogleMapManager';
import { GraphicMessageItem } from '../components/GraphicMessage/GraphicMessage';
import GraphicMessageManager from '../components/GraphicMessage/GraphicMessageManager';
import { HTMLItem } from '../components/HTML/HTML';
import HTMLManager from '../components/HTML/HTMLManager';
import { HorizontalSplitPanelItem } from '../components/HorizontalSplitPanel/HorizontalSplitPanel';
import HorizontalSplitPanelManager from '../components/HorizontalSplitPanel/HorizontalSplitPanelManager';
import { IOSSwitchItem } from '../components/IOSSwitch/IOSSwitch';
import IOSSwitchManager from '../components/IOSSwitch/IOSSwitchManager';
import { IconItem } from '../components/Icon/Icon';
import IconManager from '../components/Icon/IconManager';
import { IconButtonItem } from '../components/IconButton/IconButton';
import IconButtonManager from '../components/IconButton/IconButtonManager';
import { IconCaseItem } from '../components/IconCase/IconCase';
import IconCaseManager from '../components/IconCase/IconCaseManager';
import { IconSelectItem } from '../components/IconSelect/IconSelect';
import IconSelectManager from '../components/IconSelect/IconSelectManager';
import { IconSwitchItem } from '../components/IconSwitch/IconSwitch';
import IconSwitchManager from '../components/IconSwitch/IconSwitchManager';
import { ImageItem } from '../components/Image/Image';
import ImageManager from '../components/Image/ImageManager';
import { InputBaseItem } from '../components/InputBase/InputBase';
import InputBaseManager from '../components/InputBase/InputBaseManager';
import { IntervalItem } from '../components/Interval/Interval';
import IntervalManager from '../components/Interval/IntervalManager';
import { ImageCropperItem } from '../components/ImageCropper/ImageCropper';
import ImageCropperManager from '../components/ImageCropper/ImageCropperManager';
import { AreaItem } from '../components/IoTImageMapper/Area/Area';
import AreaManager from '../components/IoTImageMapper/Area/AreaManager';
import { AreaToolbarItem } from '../components/IoTImageMapper/AreaToolbar/AreaToolbar';
import { AreaToolbarEditItem } from '../components/IoTImageMapper/AreaToolbar/AreaToolbarEdit/AreaToolbarEdit';
import AreaToolbarEditManager from '../components/IoTImageMapper/AreaToolbar/AreaToolbarEdit/AreaToolbarEditManager';
import AreaToolbarManager from '../components/IoTImageMapper/AreaToolbar/AreaToolbarManager';
import { AreaToolbarSaveItem } from '../components/IoTImageMapper/AreaToolbar/AreaToolbarSave/AreaToolbarSave';
import AreaToolbarSaveManager from '../components/IoTImageMapper/AreaToolbar/AreaToolbarSave/AreaToolbarSaveManager';
import { AreaToolbarUndoRedoItem } from '../components/IoTImageMapper/AreaToolbar/AreaToolbarUndoRedo/AreaToolbarUndoRedo';
import AreaToolbarUndoRedoManager from '../components/IoTImageMapper/AreaToolbar/AreaToolbarUndoRedo/AreaToolbarUndoRedoManager';
import { AreaToolbarZoomItem } from '../components/IoTImageMapper/AreaToolbar/AreaToolbarZoom/AreaToolbarZoom';
import AreaToolbarZoomManager from '../components/IoTImageMapper/AreaToolbar/AreaToolbarZoom/AreaToolbarZoomManager';
import { DeviceItem } from '../components/IoTImageMapper/Device/Device';
import DeviceManager from '../components/IoTImageMapper/Device/DeviceManager';
import { IoTImageMapperItem } from '../components/IoTImageMapper/IoTImageMapper';
import IoTImageMapperManager from '../components/IoTImageMapper/IoTImageMapperManager';
import { PulseItem } from '../components/IoTImageMapper/Pulse/Pulse';
import PulseManager from '../components/IoTImageMapper/Pulse/PulseManager';
import { TrackerItem } from '../components/IoTImageMapper/Tracker/Tracker';
import TrackerManager from '../components/IoTImageMapper/Tracker/TrackerManager';
import { KanbanBoardItem } from '../components/KanbanBoard/KanbanBoard';
import KanbanBoardManager from '../components/KanbanBoard/KanbanBoardManager';
import { KanbanItemItem } from '../components/KanbanItem/KanbanItem';
import KanbanItemManager from '../components/KanbanItem/KanbanItemManager';
import { LOVFieldItem } from '../components/LOVField/LOVField';
import LOVFieldManager from '../components/LOVField/LOVFieldManager';
import { LOVGridItem } from '../components/LOVField/LOVGrid/LOVGrid';
import LOVGridManager from '../components/LOVField/LOVGrid/LOVGridManager';
import { LOVMapItem } from '../components/LOVField/LOVMap/LOVMap';
import LOVMapManager from '../components/LOVField/LOVMap/LOVMapManager';
import { LOVMappingsItem } from '../components/LOVField/LOVMappings/LOVMappings';
import LOVMappingsManager from '../components/LOVField/LOVMappings/LOVMappingsManager';
import { LanguageSelectItem } from '../components/LanguageSelect/LanguageSelect';
import LanguageSelectManager from '../components/LanguageSelect/LanguageSelectManager';
import { LinkItem } from '../components/Link/Link';
import LinkManager from '../components/Link/LinkManager';
import { LocalDataStoreItem } from '../components/LocalDataStore/LocalDataStore';
import LocalDataStoreManager from '../components/LocalDataStore/LocalDataStoreManager';
import { LookupSelectItem } from '../components/LookupSelect/LookupSelect';
import LookupSelectManager from '../components/LookupSelect/LookupSelectManager';
import { MarkdownItem } from '../components/Markdown/Markdown';
import MarkdownManager from '../components/Markdown/MarkdownManager';
import { MediaItem } from '../components/Media/Media';
import MediaManager from '../components/Media/MediaManager';
import { MenuItem } from '../components/Menu/Menu';
import MenuManager from '../components/Menu/MenuManager';
import { MenuItemItem } from '../components/MenuItem/MenuItem';
import MenuItemManager from '../components/MenuItem/MenuItemManager';
import { MenuItemDividerItem } from '../components/MenuItemDivider/MenuItemDivider';
import MenuItemDividerManager from '../components/MenuItemDivider/MenuItemDividerManager';
import { MenuItemListItem } from '../components/MenuItemList/MenuItemList';
import MenuItemListManager from '../components/MenuItemList/MenuItemListManager';
import { MetricBoxItem } from '../components/MetricBox/MetricBox';
import MetricBoxManager from '../components/MetricBox/MetricBoxManager';
import { MetricColorAndIconItem } from '../components/MetricColorAndIcon/MetricColorAndIcon';
import MetricColorAndIconManager from '../components/MetricColorAndIcon/MetricColorAndIconManager';
import { MirrorItem } from '../components/Mirror/Mirror';
import MirrorManager from '../components/Mirror/MirrorManager';
import { MultiFieldItem } from '../components/MultiField/MultiField';
import MultiFieldManager from '../components/MultiField/MultiFieldManager';
import { NumberFieldItem } from '../components/NumberField/NumberField';
import NumberFieldManager from '../components/NumberField/NumberFieldManager';
import { NumberSearchFieldItem } from '../components/NumberSearchField/NumberSearchField';
import NumberSearchFieldManager from '../components/NumberSearchField/NumberSearchFieldManager';
import { OCRComponentItem } from '../components/OCRComponent/OCRComponent';
import OCRComponentManager from '../components/OCRComponent/OCRComponentManager';
import { PageItem } from '../components/Page/Page';
import PageManager from '../components/Page/PageManager';
import { PageHeaderItem } from '../components/PageHeader/PageHeader';
import PageHeaderManager from '../components/PageHeader/PageHeaderManager';
import { PageMenuItem } from '../components/PageMenu/PageMenu';
import PageMenuManager from '../components/PageMenu/PageMenuManager';
import { PaginationItem } from '../components/Pagination/Pagination';
import PaginationManager from '../components/Pagination/PaginationManager';
import { PaperItem } from '../components/Paper/Paper';
import PaperManager from '../components/Paper/PaperManager';
import { PivotTableItem } from '../components/PivotTable/PivotTable';
import PivotTableManager from '../components/PivotTable/PivotTableManager';
import { PivotTableCalculatedColumnItem } from '../components/PivotTable/columns/PivotTableCalculatedColumn/PivotTableCalculatedColumn';
import PivotTableCalculatedColumnManager from '../components/PivotTable/columns/PivotTableCalculatedColumn/PivotTableCalculatedColumnManager';
import { PivotTableDateColumnItem } from '../components/PivotTable/columns/PivotTableDateColumn/PivotTableDateColumn';
import PivotTableDateColumnManager from '../components/PivotTable/columns/PivotTableDateColumn/PivotTableDateColumnManager';
import { PivotTableHiddenColumnItem } from '../components/PivotTable/columns/PivotTableHiddenColumn/PivotTableHiddenColumn';
import PivotTableHiddenColumnManager from '../components/PivotTable/columns/PivotTableHiddenColumn/PivotTableHiddenColumnManager';
import { PivotTableNumberColumnItem } from '../components/PivotTable/columns/PivotTableNumberColumn/PivotTableNumberColumn';
import PivotTableNumberColumnManager from '../components/PivotTable/columns/PivotTableNumberColumn/PivotTableNumberColumnManager';
import { PivotTableStringColumnItem } from '../components/PivotTable/columns/PivotTableStringColumn/PivotTableStringColumn';
import PivotTableStringColumnManager from '../components/PivotTable/columns/PivotTableStringColumn/PivotTableStringColumnManager';
import { PopoverItem } from '../components/Popover/Popover';
import PopoverManager from '../components/Popover/PopoverManager';
import { PopupItem } from '../components/Popup/Popup';
import { PopupActionsItem } from '../components/Popup/PopupActions/PopupActions';
import PopupActionsManager from '../components/Popup/PopupActions/PopupActionsManager';
import PopupManager from '../components/Popup/PopupManager';
import { PowerBIItem } from '../components/PowerBI/PowerBI';
import PowerBIManager from '../components/PowerBI/PowerBIManager';
import { ProgressIndicatorItem } from '../components/ProgressIndicator/ProgressIndicator';
import ProgressIndicatorManager from '../components/ProgressIndicator/ProgressIndicatorManager';
import { PulseTipItem } from '../components/PulseTip/PulseTip';
import PulseTipManager from '../components/PulseTip/PulseTipManager';
import { RadioBoxItem } from '../components/RadioBox/RadioBox';
import RadioBoxManager from '../components/RadioBox/RadioBoxManager';
import { RatingItem } from '../components/Rating/Rating';
import RatingManager from '../components/Rating/RatingManager';
import { ReadOnlyDataStoreItem } from '../components/ReadOnlyDataStore/ReadOnlyDataStore';
import ReadOnlyDataStoreManager from '../components/ReadOnlyDataStore/ReadOnlyDataStoreManager';
import { RichTextEditorItem } from '../components/RichTextEditor/RichTextEditor';
import RichTextEditorManager from '../components/RichTextEditor/RichTextEditorManager';
import { RowActionItem } from '../components/RowAction/RowAction';
import RowActionManager from '../components/RowAction/RowActionManager';
import { RowPanelItem } from '../components/RowPanel/RowPanel';
import RowPanelManager from '../components/RowPanel/RowPanelManager';
import { SearchCheckboxItem } from '../components/SearchCheckbox/SearchCheckbox';
import SearchCheckboxManager from '../components/SearchCheckbox/SearchCheckboxManager';
import { SearchDateFieldItem } from '../components/SearchDateField/SearchDateField';
import SearchDateFieldManager from '../components/SearchDateField/SearchDateFieldManager';
import { SearchFormItem } from '../components/SearchForm/SearchForm';
import SearchFormManager from '../components/SearchForm/SearchFormManager';
import { SearchLookupFieldItem } from '../components/SearchLookupField/SearchLookupField';
import SearchLookupFieldManager from '../components/SearchLookupField/SearchLookupFieldManager';
import { SearchNumberFieldItem } from '../components/SearchNumberField/SearchNumberField';
import SearchNumberFieldManager from '../components/SearchNumberField/SearchNumberFieldManager';
import { SearchSelectFieldItem } from '../components/SearchSelectField/SearchSelectField';
import SearchSelectFieldManager from '../components/SearchSelectField/SearchSelectFieldManager';
import { SearchTextFieldItem } from '../components/SearchTextField/SearchTextField';
import SearchTextFieldManager from '../components/SearchTextField/SearchTextFieldManager';
import { SelectItem } from '../components/Select/Select';
import SelectManager from '../components/Select/SelectManager';
import { SelectReturnValueMappingItem } from '../components/SelectReturnValueMapping/SelectReturnValueMapping';
import SelectReturnValueMappingManager from '../components/SelectReturnValueMapping/SelectReturnValueMappingManager';
import { LookupReturnValueMappingItem } from '../components/LookupReturnValueMapping/LookupReturnValueMapping';
import LookupReturnValueMappingManager from '../components/LookupReturnValueMapping/LookupReturnValueMappingManager';
import { SelectSearchFieldItem } from '../components/SelectSearchField/SelectSearchField';
import SelectSearchFieldManager from '../components/SelectSearchField/SelectSearchFieldManager';
import { SidebarDraggableListItem } from '../components/SidebarDraggableList/SidebarDraggableList';
import SidebarDraggableListManager from '../components/SidebarDraggableList/SidebarDraggableListManager';
import { SidebarHeaderItem } from '../components/SidebarHeader/SidebarHeader';
import SidebarHeaderManager from '../components/SidebarHeader/SidebarHeaderManager';
import { SidebarListItem } from '../components/SidebarList/SidebarList';
import SidebarListManager from '../components/SidebarList/SidebarListManager';
import { SidebarListItemItem } from '../components/SidebarListItem/SidebarListItem';
import SidebarListItemManager from '../components/SidebarListItem/SidebarListItemManager';
import { SidebarNavLinkItem } from '../components/SidebarNavLink/SidebarNavLink';
import SidebarNavLinkManager from '../components/SidebarNavLink/SidebarNavLinkManager';
import { SidebarNavSectionItem } from '../components/SidebarNavSection/SidebarNavSection';
import SidebarNavSectionManager from '../components/SidebarNavSection/SidebarNavSectionManager';
import { SidebarNavDropdownItem } from '../components/SidebarNavDropdown/SidebarNavDropdown';
import SidebarNavDropdownManager from '../components/SidebarNavDropdown/SidebarNavDropdownManager';
import { SidebarNavListItem } from '../components/SidebarNavList/SidebarNavList';
import SidebarNavListManager from '../components/SidebarNavList/SidebarNavListManager';
import { SidebarPanelItem } from '../components/SidebarPanel/SidebarPanel';
import SidebarPanelManager from '../components/SidebarPanel/SidebarPanelManager';
import { SidebarSpacerItem } from '../components/SidebarSpacer/SidebarSpacer';
import SidebarSpacerManager from '../components/SidebarSpacer/SidebarSpacerManager';
import { SignaturePadItem } from '../components/SignaturePad/SignaturePad';
import SignaturePadManager from '../components/SignaturePad/SignaturePadManager';
import { SimpleFilterItem } from '../components/SimpleFilter/SimpleFilter';
import SimpleFilterManager from '../components/SimpleFilter/SimpleFilterManager';
import { SimpleFilterAttributeItem } from '../components/SimpleFilterAttribute/SimpleFilterAttribute';
import SimpleFilterAttributeManager from '../components/SimpleFilterAttribute/SimpleFilterAttributeManager';
import { SmartSearchItem } from '../components/SmartSearch/SmartSearch';
import SmartSearchManager from '../components/SmartSearch/SmartSearchManager';
import { SmartSearchAttributeItem } from '../components/SmartSearchAttribute/SmartSearchAttribute';
import SmartSearchAttributeManager from '../components/SmartSearchAttribute/SmartSearchAttributeManager';
import { SpeedDialItem } from '../components/SpeedDial/SpeedDial';
import SpeedDialManager from '../components/SpeedDial/SpeedDialManager';
import { SpeedDialActionItem } from '../components/SpeedDialAction/SpeedDialAction';
import SpeedDialActionManager from '../components/SpeedDialAction/SpeedDialActionManager';
import { StartIconItem } from '../components/StartIcon/StartIcon';
import StartIconManager from '../components/StartIcon/StartIconManager';
import { StepItem } from '../components/Step/Step';
import StepManager from '../components/Step/StepManager';
import { StepperItem } from '../components/Stepper/Stepper';
import StepperManager from '../components/Stepper/StepperManager';
import { SuspendPageItem } from '../components/SuspendPage/SuspendPage';
import SuspendPageManager from '../components/SuspendPage/SuspendPageManager';
import { SwitchRoleItem } from '../components/SwitchRole/SwitchRole';
import SwitchRoleManager from '../components/SwitchRole/SwitchRoleManager';
import { TabItemItem } from '../components/TabItem/TabItem';
import TabItemManager from '../components/TabItem/TabItemManager';
import { TabPanelItem } from '../components/TabPanel/TabPanel';
import TabPanelManager from '../components/TabPanel/TabPanelManager';
import { TextItem } from '../components/Text/Text';
import TextManager from '../components/Text/TextManager';
import { TextFieldItem } from '../components/TextField/TextField';
import TextFieldManager from '../components/TextField/TextFieldManager';
import { TextSearchFieldItem } from '../components/TextSearchField/TextSearchField';
import TextSearchFieldManager from '../components/TextSearchField/TextSearchFieldManager';
import { TimelineItem } from '../components/Timeline/Timeline';
import TimelineManager from '../components/Timeline/TimelineManager';
import { TimelineConnectorItem } from '../components/TimelineConnector/TimelineConnector';
import TimelineConnectorManager from '../components/TimelineConnector/TimelineConnectorManager';
import { TimelineContentItem } from '../components/TimelineContent/TimelineContent';
import TimelineContentManager from '../components/TimelineContent/TimelineContentManager';
import { TimelineDotItem } from '../components/TimelineDot/TimelineDot';
import TimelineDotManager from '../components/TimelineDot/TimelineDotManager';
import { TimelineItemItem } from '../components/TimelineItem/TimelineItem';
import TimelineItemManager from '../components/TimelineItem/TimelineItemManager';
import { TimelineOppositeContentItem } from '../components/TimelineOppositeContent/TimelineOppositeContent';
import TimelineOppositeContentManager from '../components/TimelineOppositeContent/TimelineOppositeContentManager';
import { TimelineSeparatorItem } from '../components/TimelineSeparator/TimelineSeparator';
import TimelineSeparatorManager from '../components/TimelineSeparator/TimelineSeparatorManager';
import { ToolbarItem } from '../components/Toolbar/Toolbar';
import ToolbarManager from '../components/Toolbar/ToolbarManager';
import { ToolbarDividerItem } from '../components/ToolbarDivider/ToolbarDivider';
import ToolbarDividerManager from '../components/ToolbarDivider/ToolbarDividerManager';
import { ToolbarSpacerItem } from '../components/ToolbarSpacer/ToolbarSpacer';
import ToolbarSpacerManager from '../components/ToolbarSpacer/ToolbarSpacerManager';
import { TransactionItem } from '../components/Transaction/Transaction';
import TransactionManager from '../components/Transaction/TransactionManager';
import { TransactionMappingItem } from '../components/TransactionMapping/TransactionMapping';
import TransactionMappingManager from '../components/TransactionMapping/TransactionMappingManager';
import { TransientDataStoreItem } from '../components/TransientDataStore/TransientDataStore';
import TransientDataStoreManager from '../components/TransientDataStore/TransientDataStoreManager';
import {
  H1Item,
  H2Item,
  H3Item,
  H4Item,
  H5Item,
  H6Item,
  TypographyItem,
} from '../components/Typography/Typography';
import {
  H1Manager,
  H2Manager,
  H3Manager,
  H4Manager,
  H5Manager,
  H6Manager,
  TypographyManager,
} from '../components/Typography/TypographyManager';
import { UploadFileToFunctionItem } from '../components/UploadFileToFunction/UploadFileToFunction';
import UploadFileToFunctionManager from '../components/UploadFileToFunction/UploadFileToFunctionManager';
import { UserListItem } from '../components/UserList/UserList';
import UserListManager from '../components/UserList/UserListManager';
import { UserPicItem } from '../components/UserPic/UserPic';
import UserPicManager from '../components/UserPic/UserPicManager';
import { UserProfileMenuItem } from '../components/UserProfileMenu/UserProfileMenu';
import UserProfileMenuManager from '../components/UserProfileMenu/UserProfileMenuManager';
import { VerticalSplitPanelItem } from '../components/VerticalSplitPanel/VerticalSplitPanel';
import VerticalSplitPanelManager from '../components/VerticalSplitPanel/VerticalSplitPanelManager';
import { ViewAttachmentItem } from '../components/ViewAttachment/ViewAttachment';
import ViewAttachmentManager from '../components/ViewAttachment/ViewAttachmentManager';
import { WaveDotsItem } from '../components/WaveDots/WaveDots';
import WaveDotsManager from '../components/WaveDots/WaveDotsManager';
import { WorkflowViewerItem } from '../components/WorkflowViewer/WorkflowViewer';
import WorkflowViewerManager from '../components/WorkflowViewer/WorkflowViewerManager';
import { Platform } from '../platform/Platform';
import {
  TriggerAfterQueryItem,
  TriggerAfterSaveItem,
  TriggerBeforeCreateItem,
  TriggerBeforeQueryItem,
  TriggerBeforeSaveItem,
  TriggerOnAggregateClickItem,
  TriggerOnBlurItem,
  TriggerOnCellClickItem,
  TriggerOnChangeItem,
  TriggerOnClickItem,
  TriggerOnCommentItem,
  TriggerOnCreateItem,
  TriggerOnDeleteItem,
  TriggerOnDoubleClickItem,
  TriggerOnEventChangeItem,
  TriggerOnEventClickItem,
  TriggerOnEventCreateItem,
  TriggerOnExtraLargeScreenItem,
  TriggerOnExtraSmallScreenItem,
  TriggerOnFocusItem,
  TriggerOnInitializeItem,
  TriggerOnKeyDownItem,
  TriggerOnLandscapeScreenItem,
  TriggerOnLargeScreenItem,
  TriggerOnMediumScreenItem,
  TriggerOnMentionItem,
  TriggerOnMouseEnterItem,
  TriggerOnMouseLeaveItem,
  TriggerOnPageActiveItem,
  TriggerOnPageExitItem,
  TriggerOnPopoverCloseItem,
  TriggerOnPopoverOpenItem,
  TriggerOnPopupCloseItem,
  TriggerOnPopupOpenItem,
  TriggerOnPortraitScreenItem,
  TriggerOnResponseItem,
  TriggerOnRowClickItem,
  TriggerOnRowDoubleClickItem,
  TriggerOnSearchItem,
  TriggerOnSmallScreenItem,
  TriggerOnSubmitItem,
  TriggerOnSubscriptionEventItem,
  TriggerOnTabActiveItem,
  TriggerAfterServerValidateItem,
  TriggerAfterUploadItem,
  TriggerAfterPasteItem,
  TriggerOnPasteItem,
  TriggerOnDeleteKeyPressItem,
  TriggerOnEnterKeyPressItem,
  TriggerOnRecordActiveItem,
  TriggerAfterDeleteRecordItem,
  TriggerBeforeDeleteRecordItem,
  TriggerAfterInsertStoreRecordItem,
  TriggerBeforeInsertStoreRecordItem,
  TriggerOnIconClickItem,
  TriggerOnTreeColumnExpandItem,
  TriggerOnTabExitItem,
  TriggerOnValueChangeItem,
  TriggerOnWindowSizeChangeItem,
} from '../triggers/Triggers';
import TriggersManager from '../triggers/TriggersManager';
import {
  ActionItemType,
  ComponentItemType,
  ComponentItemTypeRegistry,
  ItemType,
  TriggerItemType,
  TriggerItemTypeRegistry,
} from './Base.type';
import {
  ActionManager,
  ActionManagerFn,
  AnyManager,
  AnyManagerFn,
  BaseComponentItem,
  ComponentManager,
  ComponentManagerFn,
  TriggerManager,
  TriggerManagerFn,
} from './Component.type';
import { getManager, registerManager } from './Manager';
import { ActionExpandAllItem } from '../actions/ActionExpandAll/ActionExpandAll';
import ActionExpandAllManager from '../actions/ActionExpandAll/ActionExpandAllManager';
import { ActionCollapseAllItem } from '../actions/ActionCollapseAll/ActionCollapseAll';
import ActionCollapseAllManager from '../actions/ActionCollapseAll/ActionCollapseAllManager';
import { MutliSelectLOVFieldItem } from '../components/MutliSelectLOVField/MutliSelectLOVField';
import MutliSelectLOVFieldManager from '../components/MutliSelectLOVField/MutliSelectLOVFieldManager';
import MultiSelectLOVColumnManager from 'componentregistry/components/DataGrid/columns/MultiSelectLOVColumn/MultiSelectLOVColumnManager';
import { MultiSelectLOVColumnItem } from 'componentregistry/components/DataGrid/columns/MultiSelectLOVColumn/MultiSelectLOVColumn';
import { ActionCopyRecordInLoopItem } from '../actions/ActionCopyRecordInLoop/ActionCopyRecordInLoop';
import ActionCopyRecordInLoopManager from '../actions/ActionCopyRecordInLoop/ActionCopyRecordInLoopManager';
import { CalendarSourceEventItem } from 'componentregistry/components/CalendarSourceEvent/CalendarSourceEvent';
import CalendarSourceEventManager from 'componentregistry/components/CalendarSourceEvent/CalendarSourceEventManager';
import { ActionQueryCalendarItem } from '../actions/ActionQueryCalendar/ActionQueryCalendar';
import ActionQueryCalendarManager from '../actions/ActionQueryCalendar/ActionQueryCalendarManager';
import { MultiDateSelectorItem } from '../components/MultiDateSelector/MultiDateSelector';
import MultiDateSelectorManager from '../components/MultiDateSelector/MultiDateSelectorManager';
import { FusionChartsIOItem } from '../components/FusionChartsIO/FusionChartsIO';
import FusionChartsIOManager from '../components/FusionChartsIO/FusionChartsIOManager';
import { FusionMapsItem } from '../components/FusionMaps/FusionMaps';
import FusionMapsManager from '../components/FusionMaps/FusionMapsManager';
import { CombinationChartFCItem } from '../components/CombinationChartFC/CombinationChartFC';
import CombinationChartFCManager from '../components/CombinationChartFC/CombinationChartFCManager';
import { MultiSeriesChartItem } from '../components/MultiSeriesChart/MultiSeriesChart';
import MultiSeriesChartManager from '../components/MultiSeriesChart/MultiSeriesChartManager';
import { AngularGaugeItem } from '../components/AngularGauge/AngularGauge';
import AngularGaugeManager from '../components/AngularGauge/AngularGaugeManager';
import { ActionSetEmbedDataItem } from '../actions/ActionSetEmbedData/ActionSetEmbedData';
import ActionSetEmbedDataManager from '../actions/ActionSetEmbedData/ActionSetEmbedDataManager';
import { ActionQueryAdditionalDatasourceItem } from '../actions/ActionQueryAdditionalDatasource/ActionQueryAdditionalDatasource';
import ActionQueryAdditionalDatasourceManager from '../actions/ActionQueryAdditionalDatasource/ActionQueryAdditionalDatasourceManager';
import { ActionInvokeDataSourceItem } from '../actions/ActionInvokeDataSource/ActionInvokeDataSource';
import ActionInvokeDataSourceManager from '../actions/ActionInvokeDataSource/ActionInvokeDataSourceManager';
import { ActionInputMappingItem } from '../actions/ActionInputMapping/ActionInputMapping';
import ActionInputMappingManager from '../actions/ActionInputMapping/ActionInputMappingManager';
import { ActionOutputMappingItem } from '../actions/ActionOutputMapping/ActionOutputMapping';
import ActionOutputMappingManager from '../actions/ActionOutputMapping/ActionOutputMappingManager';
import { GridPersonalizationMenuItem } from '../components/GridPersonalizationMenu/GridPersonalizationMenu';
import GridPersonalizationMenuManager from '../components/GridPersonalizationMenu/GridPersonalizationMenuManager';
import { CarouselItem } from '../components/Carousel/Carousel';
import CarouselManager from '../components/Carousel/CarouselManager';
import { TableauItem } from '../components/Tableau/Tableau';
import TableauManager from '../components/Tableau/TableauManager';
import { OrganizationChartItem } from '../components/OrganizationChart/OrganizationChart';
import OrganizationChartManager from '../components/OrganizationChart/OrganizationChartManager';
import { ActionStartPageMaskItem } from '../actions/ActionStartPageMask/ActionStartPageMask';
import ActionStartPageMaskManager from '../actions/ActionStartPageMask/ActionStartPageMaskManager';
import { ActionEndPageMaskItem } from '../actions/ActionEndPageMask/ActionEndPageMask';
import ActionEndPageMaskManager from '../actions/ActionEndPageMask/ActionEndPageMaskManager';
import { ActionClearMessagesItem } from '../actions/ActionClearMessages/ActionClearMessages';
import ActionClearMessagesManager from '../actions/ActionClearMessages/ActionClearMessagesManager';
import { IFrameItem } from '../components/IFrame/IFrame';
import IFrameManager from '../components/IFrame/IFrameManager';
import { ChatBotItem } from '../components/ChatBot/ChatBot';
import ChatBotManager from '../components/ChatBot/ChatBotManager';
import { SparkLineItem } from '../components/SparkLine/SparkLine';
import SparkLineManager from '../components/SparkLine/SparkLineManager';
/* IMPORT ABOVE */

export type AnyActionItem =
  | ActionClearMessagesItem
  | ActionEndPageMaskItem
  | ActionStartPageMaskItem
  | ActionOutputMappingItem
  | ActionInputMappingItem
  | ActionInvokeDataSourceItem
  | ActionSetEmbedDataItem
  | ActionQueryAdditionalDatasourceItem
  | ActionQueryCalendarItem
  | ActionCopyRecordInLoopItem
  | ActionCollapseAllItem
  | ActionExpandAllItem
  | ActionAbortItem
  | ActionAddSmartSearchFiltersFromAggregateItem
  | ActionApproveWorkflowItem
  | ActionBatchItem
  | ActionBrowserRefreshItem
  | ActionClearFiltersItem
  | ActionClearItem
  | ActionClearStoreCacheItem
  | ActionCloseDrawerItem
  | ActionClosePopoverItem
  | ActionClosePopupItem
  | ActionCopyFilterAttributeItem
  | ActionCopyFiltersItem
  | ActionCopyRecordItem
  | ActionCopySmartSearchFiltersItem
  | ActionCopyToClipboardItem
  | ActionCreateItem
  | ActionDeleteCurrentRecordItem
  | ActionDeleteSelectedRecordsItem
  | ActionDeselectAllItem
  | ActionDeselectBreadcrumbNavigationLeafNodeItem
  | ActionDeselectRecordItem
  | ActionDownloadAttachmentItem
  | ActionDownloadChartDataItem
  | ActionDownloadChartImageItem
  | ActionDuplicateRecordItem
  | ActionExportDataItem
  | ActionFocusItem
  | ActionForceUpdateItem
  | ActionGoBackItem
  | ActionGoToAddDataSourceItem
  | ActionGoToAddFunctionItem
  | ActionGoToAddPageItem
  | ActionGoToAddRoleItem
  | ActionGoToAddUserItem
  | ActionGoToAddWorkflowItem
  | ActionGoToFirstRecordItem
  | ActionGoToLastRecordItem
  | ActionGoToNextRecordItem
  | ActionGoToPageItem
  | ActionGoToPreviousRecordItem
  | ActionGoToViewDataSourcesItem
  | ActionGoToViewFunctionsItem
  | ActionGoToViewPagesItem
  | ActionGoToViewRolesItem
  | ActionGoToViewUsersItem
  | ActionGoToViewWorkflowsItem
  | ActionHideItem
  | ActionImportItem
  | ActionInvokeCloudFunctionItem
  | ActionInvokeControllerFunctionItem
  | ActionInvokeTriggerItem
  | ActionInvokeUIScriptItem
  | ActionLoadDataItem
  | ActionLogToConsoleItem
  | ActionLoopDeselectItem
  | ActionLoopRecordsItem
  | ActionLoopSelectItem
  | ActionMatchRecordItem
  | ActionNavigateToPageLinkItem
  | ActionNotifyRolesItem
  | ActionNotifyUsersItem
  | ActionOnCancelItem
  | ActionOnConfirmItem
  | ActionOnMatchFoundItem
  | ActionOnMatchNotFoundItem
  | ActionOnResponseItem
  | ActionOnTimeoutItem
  | ActionOpenAttachmentRevisionsItem
  | ActionOpenCommentsItem
  | ActionOpenDrawerItem
  | ActionOpenPopoverItem
  | ActionOpenPopupItem
  | ActionOpenSignaturePadItem
  | ActionOpenURLItem
  | ActionOpenUserProfileItem
  | ActionParallelItem
  | ActionPublishEventItem
  | ActionQueryChartItem
  | ActionQueryItem
  | ActionQuerySelectItem
  | ActionRedrawCanvasGridItem
  | ActionReduceItem
  | ActionRefreshItem
  | ActionRejectWorkflowItem
  | ActionRemoveURLParamItem
  | ActionResetCurrentRecordItem
  | ActionResetItem
  | ActionRunJSItem
  | ActionSaveItem
  | ActionSaveTransactionItem
  | ActionSelectAllItem
  | ActionSelectBreadcrumbNavigationLeafNodeItem
  | ActionSelectRecordItem
  | ActionSendEmailItem
  | ActionSetAggregateAttributeItem
  | ActionSetAttributeErrorItem
  | ActionSetBIFilterParamItem
  | ActionSetCurrentRecordItem
  | ActionSetDataItem
  | ActionSetDefaultFiltersItem
  | ActionSetDistinctItem
  | ActionSetFilterCombinerItem
  | ActionSetGroupByAttributeItem
  | ActionSetItem
  | ActionSetParamItem
  | ActionSetProjectionItem
  | ActionSetQueryFilterItem
  | ActionSetSimpleQueryFilterItem
  | ActionSetSortItem
  | ActionShareURLItem
  | ActionShowAuditItem
  | ActionShowItem
  | ActionShowMessageItem
  | ActionSignOutItem
  | ActionSleepItem
  | ActionSwitchCaseItem
  | ActionSwitchItem
  | ActionURLParamItem
  | ActionUpdatePropItem
  | ActionUpdateRecordItem
  | ActionUserConfirmationItem
  | ActionWaitForItem;

export type AnyTriggerItem =
  | TriggerAfterServerValidateItem
  | TriggerAfterUploadItem
  | TriggerAfterPasteItem
  | TriggerOnPasteItem
  | TriggerOnDeleteKeyPressItem
  | TriggerOnEnterKeyPressItem
  | TriggerOnRecordActiveItem
  | TriggerAfterDeleteRecordItem
  | TriggerBeforeDeleteRecordItem
  | TriggerAfterInsertStoreRecordItem
  | TriggerBeforeInsertStoreRecordItem
  | TriggerOnIconClickItem
  | TriggerOnTreeColumnExpandItem
  | TriggerAfterQueryItem
  | TriggerAfterSaveItem
  | TriggerBeforeCreateItem
  | TriggerBeforeQueryItem
  | TriggerBeforeSaveItem
  | TriggerOnAggregateClickItem
  | TriggerOnBlurItem
  | TriggerOnCellClickItem
  | TriggerOnChangeItem
  | TriggerOnClickItem
  | TriggerOnCommentItem
  | TriggerOnCreateItem
  | TriggerOnDeleteItem
  | TriggerOnDoubleClickItem
  | TriggerOnEventChangeItem
  | TriggerOnEventClickItem
  | TriggerOnEventCreateItem
  | TriggerOnExtraLargeScreenItem
  | TriggerOnExtraSmallScreenItem
  | TriggerOnFocusItem
  | TriggerOnInitializeItem
  | TriggerOnKeyDownItem
  | TriggerOnLandscapeScreenItem
  | TriggerOnLargeScreenItem
  | TriggerOnMediumScreenItem
  | TriggerOnMentionItem
  | TriggerOnMouseEnterItem
  | TriggerOnMouseLeaveItem
  | TriggerOnPageActiveItem
  | TriggerOnPageExitItem
  | TriggerOnPopoverCloseItem
  | TriggerOnPopoverOpenItem
  | TriggerOnPopupCloseItem
  | TriggerOnPopupOpenItem
  | TriggerOnPortraitScreenItem
  | TriggerOnResponseItem
  | TriggerOnRowClickItem
  | TriggerOnRowDoubleClickItem
  | TriggerOnSearchItem
  | TriggerOnSmallScreenItem
  | TriggerOnSubmitItem
  | TriggerOnSubscriptionEventItem
  | TriggerOnTabActiveItem
  | TriggerOnTabExitItem
  | TriggerOnValueChangeItem
  | TriggerOnWindowSizeChangeItem;

export type AnyColumn =
  | AnyTableColumn
  | AsyncSelectColumnItem
  | LOVColumnItem
  | MultiSelectLOVColumnItem;

export type AnyTableColumn =
  | ActionIconsColumnItem
  | AttachmentColumnItem
  | ButtonColumnItem
  | CheckboxColumnItem
  | DateColumnItem
  | DivColumnItem
  | FormulaNumberColumnItem
  | FormulaStringColumnItem
  | IconColumnItem
  | ImageColumnItem
  | LookupSelectColumnItem
  | NumberColumnItem
  | ProgressIndicatorColumnItem
  | RowNumberColumnItem
  | RowSelectionColumnItem
  | SelectColumnItem
  | StarColumnItem
  | StringColumnItem
  | SwitchColumnItem
  | TreeColumnItem
  | UserPicColumnItem;

export type AnyFormulaColumn =
  | FormulaNumberColumnItem
  | FormulaStringColumnItem;

export type AnyCompItem =
  | ChatBotItem
  | SparkLineItem
  | IFrameItem
  | OrganizationChartItem
  | TableauItem
  | CarouselItem
  | GridPersonalizationMenuItem
  | AngularGaugeItem
  | FusionMapsItem
  | CombinationChartFCItem
  | MultiSeriesChartItem
  | MultiDateSelectorItem
  | CalendarSourceEventItem
  | MutliSelectLOVFieldItem
  | AccordionItem
  | ActionButtonItem
  | ActiveUsersItem
  | AlertItem
  | AreaItem
  | AreaToolbarEditItem
  | AreaToolbarItem
  | AreaToolbarSaveItem
  | AreaToolbarUndoRedoItem
  | AreaToolbarZoomItem
  | AsyncSelectItem
  | AttachmentFieldItem
  | AttachmentRevisionsItem
  | AutoSizerItem
  | AvatarItem
  | AvatarListItem
  | BadgeItem
  | BingMapItem
  | BingMapNavigatorItem
  | BoxContainerItem
  | BoxItem
  | BoxListItem
  | BreadcrumbItem
  | BreadcrumbItemItem
  | BreadcrumbNavigationItem
  | ButtonDropdownChildItem
  | ButtonDropdownItem
  | ButtonGroupItem
  | ButtonItem
  | CalendarHeatmapItem
  | CalendarItem
  | CanvasGridItem
  | CardActionsItem
  | CardContentItem
  | CardHeaderItem
  | CardItem
  | ChartJSTooltipItem
  | ChartJSTreemapItem
  | ChartjsItem
  | CheckboxItem
  | CheckboxSearchFieldItem
  | ChipItem
  | ChipsItem
  | ClientSideExcelUploadItem
  | ClipboardItem
  | CloudDataStoreItem
  | CodeItem
  | CollectionListItem
  | ColumnFooterItem
  | ColumnPanelItem
  | CombinationChartItem
  | CommentActionMenuItemsItem
  | CommentsItem
  | CommentsPanelItem
  | ControllerComponentItem
  | CustomComponentItem
  | D3ChartItem
  | DarkModeToggleItem
  | DataGridItem
  | DataListItem
  | DataStoreItem
  | DataStoreReferenceItem
  | DateFieldItem
  | DateSearchFieldItem
  | DeviceItem
  | DiffCheckerItem
  | DividerItem
  | DragSourceBoxItem
  | DragSourceItem
  | DrawerItem
  | DropTargetBoxItem
  | DropTargetItem
  | EmbedPageItem
  | EmptySpacerItem
  | EndIconItem
  | EventSubscriptionItem
  | ExcelViewerItem
  | ExpressionWatchListenerItem
  | ExpressionBuilderFieldItem
  | ExpressionWatcherItem
  | FABItem
  | FlexItemItem
  | FlexPanelItem
  | FloatingPanelItem
  | FolderItem
  | FormItem
  | FormSearchItem
  | FullScreenToggleItem
  | FusionChartsIOItem
  | FunctionEditorItem
  | GoogleMapItem
  | GraphicMessageItem
  | H1Item
  | H2Item
  | H3Item
  | H4Item
  | H5Item
  | H6Item
  | HTMLItem
  | HorizontalSplitPanelItem
  | IOSSwitchItem
  | IconButtonItem
  | IconCaseItem
  | IconItem
  | IconSelectItem
  | IconSwitchItem
  | ImageItem
  | InfoBoxItem
  | InputBaseItem
  | IntervalItem
  | IoTImageMapperItem
  | ImageCropperItem
  | KanbanBoardItem
  | KanbanItemItem
  | LOVFieldItem
  | LOVGridItem
  | LOVMapItem
  | LOVMappingsItem
  | LanguageSelectItem
  | LinkItem
  | LocalDataStoreItem
  | LookupSelectItem
  | MarkdownItem
  | MediaItem
  | MenuItem
  | MenuItemDividerItem
  | MenuItemItem
  | MenuItemListItem
  | MetricBoxItem
  | MetricColorAndIconItem
  | MirrorItem
  | MultiFieldItem
  | NumberFieldItem
  | NumberSearchFieldItem
  | OCRComponentItem
  | PageHeaderItem
  | PageItem
  | PageMenuItem
  | PaginationItem
  | PaperItem
  | PivotTableCalculatedColumnItem
  | PivotTableDateColumnItem
  | PivotTableHiddenColumnItem
  | PivotTableItem
  | PivotTableNumberColumnItem
  | PivotTableStringColumnItem
  | PopoverItem
  | PopupActionsItem
  | PopupItem
  | PowerBIItem
  | ProgressIndicatorItem
  | PulseItem
  | PulseTipItem
  | RadioBoxItem
  | RatingItem
  | ReadOnlyDataStoreItem
  | RichTextEditorItem
  | RowActionItem
  | RowPanelItem
  | SearchCheckboxItem
  | SearchDateFieldItem
  | SearchFormItem
  | SearchLookupFieldItem
  | SearchNumberFieldItem
  | SearchSelectFieldItem
  | SearchTextFieldItem
  | SelectItem
  | SelectReturnValueMappingItem
  | LookupReturnValueMappingItem
  | SelectSearchFieldItem
  | SidebarDraggableListItem
  | SidebarHeaderItem
  | SidebarListItem
  | SidebarListItemItem
  | SidebarNavLinkItem
  | SidebarNavSectionItem
  | SidebarNavDropdownItem
  | SidebarNavListItem
  | SidebarPanelItem
  | SidebarSpacerItem
  | SignaturePadItem
  | SimpleFilterAttributeItem
  | SimpleFilterItem
  | SmartSearchAttributeItem
  | SmartSearchItem
  | SpeedDialActionItem
  | SpeedDialItem
  | StartIconItem
  | StepItem
  | StepperItem
  | SuspendPageItem
  | SwitchColumnCaseItem
  | SwitchRoleItem
  | TabItemItem
  | TabPanelItem
  | TextFieldItem
  | TextItem
  | TextSearchFieldItem
  | TimelineConnectorItem
  | TimelineContentItem
  | TimelineDotItem
  | TimelineItem
  | TimelineItemItem
  | TimelineOppositeContentItem
  | TimelineSeparatorItem
  | ToolbarDividerItem
  | ToolbarItem
  | ToolbarSpacerItem
  | TrackerItem
  | TransactionItem
  | TransactionMappingItem
  | TransientDataStoreItem
  | TypographyItem
  | UploadFileToFunctionItem
  | UserListItem
  | UserPicItem
  | UserProfileMenuItem
  | VerticalSplitPanelItem
  | ViewAttachmentItem
  | WaveDotsItem
  | WorkflowViewerItem;

export * from './Base.type';
export type { BaseComponentItem };
export {
  ComponentKeys,
  TriggerKeys,
  ActionKeys,
  hmrReplace,
  init,
  getMgr,
  testComponents,
};

export type AnyItem = BaseComponentItem;

export type AnyComponentItem = AnyCompItem | AnyColumn;

export interface Page {
  [key: string]: AnyItem;
}

/*
 * Make sure to sort when adding a new action. The actions on the context menu
 * will be display in the same order in which it's listed here
 */
const ActionRegistry: {
  [K in ActionItemType]: ActionManagerFn<K>;
} = {
  ActionExpandAll: ActionExpandAllManager,
  ActionCollapseAll: ActionCollapseAllManager,
  ActionCopyRecordInLoop: ActionCopyRecordInLoopManager,
  ActionQueryCalendar: ActionQueryCalendarManager,
  ActionSetEmbedData: ActionSetEmbedDataManager,
  ActionQueryAdditionalDatasource: ActionQueryAdditionalDatasourceManager,
  ActionInvokeDataSource: ActionInvokeDataSourceManager,
  ActionInputMapping: ActionInputMappingManager,
  ActionOutputMapping: ActionOutputMappingManager,
  ActionStartPageMask: ActionStartPageMaskManager,
  ActionEndPageMask: ActionEndPageMaskManager,
  ActionClearMessages: ActionClearMessagesManager,
  ActionAbort: ActionAbortManager,
  ActionAddSmartSearchFiltersFromAggregate:
    ActionAddSmartSearchFiltersFromAggregateManager,
  ActionApproveWorkflow: ActionApproveWorkflowManager,
  ActionBatch: ActionBatchManager,
  ActionBrowserRefresh: ActionBrowserRefreshManager,
  ActionClear: ActionClearManager,
  ActionClearFilters: ActionClearFiltersManager,
  ActionClearStoreCache: ActionClearStoreCacheManager,
  ActionCloseDrawer: ActionCloseDrawerManager,
  ActionClosePopover: ActionClosePopoverManager,
  ActionClosePopup: ActionClosePopupManager,
  ActionCopyFilterAttribute: ActionCopyFilterAttributeManager,
  ActionCopyFilters: ActionCopyFiltersManager,
  ActionCopyRecord: ActionCopyRecordManager,
  ActionCopySmartSearchFilters: ActionCopySmartSearchFiltersManager,
  ActionCopyToClipboard: ActionCopyToClipboardManager,
  ActionCreate: ActionCreateManager,
  ActionDeleteCurrentRecord: ActionDeleteCurrentRecordManager,
  ActionDeleteSelectedRecords: ActionDeleteSelectedRecordsManager,
  ActionDeselectAll: ActionDeselectAllManager,
  ActionDeselectBreadcrumbNavigationLeafNode:
    ActionDeselectBreadcrumbNavigationLeafNodeManager,
  ActionDeselectRecord: ActionDeselectRecordManager,
  ActionDownloadAttachment: ActionDownloadAttachmentManager,
  ActionDownloadChartData: ActionDownloadChartDataManager,
  ActionDownloadChartImage: ActionDownloadChartImageManager,
  ActionDuplicateRecord: ActionDuplicateRecordManager,
  ActionExportData: ActionExportDataManager,
  ActionFocus: ActionFocusManager,
  ActionForceUpdate: ActionForceUpdateManager,
  ActionGoBack: ActionGoBackManager,
  ActionGoToAddDataSource: ActionGoToAddDataSourceManager,
  ActionGoToAddFunction: ActionGoToAddFunctionManager,
  ActionGoToAddPage: ActionGoToAddPageManager,
  ActionGoToAddRole: ActionGoToAddRoleManager,
  ActionGoToAddUser: ActionGoToAddUserManager,
  ActionGoToAddWorkflow: ActionGoToAddWorkflowManager,
  ActionGoToFirstRecord: ActionGoToRecordManager('ActionGoToFirstRecord'),
  ActionGoToLastRecord: ActionGoToRecordManager('ActionGoToLastRecord'),
  ActionGoToNextRecord: ActionGoToRecordManager('ActionGoToNextRecord'),
  ActionGoToPage: ActionGoToPageManager,
  ActionGoToPreviousRecord: ActionGoToRecordManager('ActionGoToPreviousRecord'),
  ActionGoToViewDataSources: ActionGoToViewDataSourcesManager,
  ActionGoToViewFunctions: ActionGoToViewFunctionsManager,
  ActionGoToViewPages: ActionGoToViewPagesManager,
  ActionGoToViewRoles: ActionGoToViewRolesManager,
  ActionGoToViewUsers: ActionGoToViewUsersManager,
  ActionGoToViewWorkflows: ActionGoToViewWorkflowsManager,
  ActionHide: ActionHideManager,
  ActionImport: ActionImportManager,
  ActionInvokeCloudFunction: ActionInvokeCloudFunctionManager,
  ActionInvokeControllerFunction: ActionInvokeControllerFunctionManager,
  ActionInvokeTrigger: ActionInvokeTriggerManager,
  ActionInvokeUIScript: ActionInvokeUIScriptManager,
  ActionLoadData: ActionLoadDataManager,
  ActionLogToConsole: ActionLogToConsoleManager,
  ActionLoopDeselect: ActionLoopDeselectManager,
  ActionLoopRecords: ActionLoopRecordsManager,
  ActionLoopSelect: ActionLoopSelectManager,
  ActionMatchRecord: ActionMatchRecordManager,
  ActionNavigateToPageLink: ActionNavigateToPageLinkManager,
  ActionNotifyRoles: ActionNotifyRolesManager,
  ActionNotifyUsers: ActionNotifyUsersManager,
  ActionOnCancel: ActionOnCancelManager,
  ActionOnConfirm: ActionOnConfirmManager,
  ActionOnMatchFound: ActionOnMatchFoundManager,
  ActionOnMatchNotFound: ActionOnMatchNotFoundManager,
  ActionOnResponse: ActionOnResponseManager,
  ActionOnTimeout: ActionOnTimeoutManager,
  ActionOpenAttachmentRevisions: ActionOpenAttachmentRevisionsManager,
  ActionOpenComments: ActionOpenCommentsManager,
  ActionOpenDrawer: ActionOpenDrawerManager,
  ActionOpenPopover: ActionOpenPopoverManager,
  ActionOpenPopup: ActionOpenPopupManager,
  ActionOpenSignaturePad: ActionOpenSignaturePadManager,
  ActionOpenURL: ActionOpenURLManager,
  ActionOpenUserProfile: ActionOpenUserProfileManager,
  ActionParallel: ActionParallelManager,
  ActionPublishEvent: ActionPublishEventManager,
  ActionQuery: ActionQueryManager,
  ActionQueryChart: ActionQueryChartManager,
  ActionQuerySelect: ActionQuerySelectManager,
  ActionRedrawCanvasGrid: ActionRedrawCanvasGridManager,
  ActionReduce: ActionReduceManager,
  ActionRefresh: ActionRefreshManager,
  ActionRejectWorkflow: ActionRejectWorkflowManager,
  ActionRemoveURLParam: ActionRemoveURLParamManager,
  ActionReset: ActionResetManager,
  ActionResetCurrentRecord: ActionResetCurrentRecordManager,
  ActionRunJS: ActionRunJSManager,
  ActionSave: ActionSaveManager,
  ActionSaveTransaction: ActionSaveTransactionManager,
  ActionSelectAll: ActionSelectAllManager,
  ActionSelectBreadcrumbNavigationLeafNode:
    ActionSelectBreadcrumbNavigationLeafNodeManager,
  ActionSelectRecord: ActionSelectRecordManager,
  ActionSendEmail: ActionSendEmailManager,
  ActionSet: ActionSetManager,
  ActionSetAggregateAttribute: ActionSetAggregateAttributeManager,
  ActionSetAttributeError: ActionSetAttributeErrorManager,
  ActionSetBIFilterParam: ActionSetBIFilterParamManager,
  ActionSetCurrentRecord: ActionSetCurrentRecordManager,
  ActionSetData: ActionSetDataManager,
  ActionSetDefaultFilters: ActionSetDefaultFiltersManager,
  ActionSetDistinct: ActionSetDistinctManager,
  ActionSetFilterCombiner: ActionSetFilterCombinerManager,
  ActionSetGroupByAttribute: ActionSetGroupByAttributeManager,
  ActionSetParam: ActionSetParamManager,
  ActionSetProjection: ActionSetProjectionManager,
  ActionSetQueryFilter: ActionSetQueryFilterManager,
  ActionSetSimpleQueryFilter: ActionSetSimpleQueryFilterManager,
  ActionSetSort: ActionSetSortManager,
  ActionShareURL: ActionShareURLManager,
  ActionShow: ActionShowManager,
  ActionShowAudit: ActionShowAuditManager,
  ActionShowMessage: ActionShowMessageManager,
  ActionSignOut: ActionSignOutManager,
  ActionSleep: ActionSleepManager,
  ActionSwitch: ActionSwitchManager,
  ActionSwitchCase: ActionSwitchCaseManager,
  ActionURLParam: ActionURLParamManager,
  ActionUpdateProp: ActionUpdatePropManager,
  ActionUpdateRecord: ActionUpdateRecordManager,
  ActionUserConfirmation: ActionUserConfirmationManager,
  ActionWaitFor: ActionWaitForManager,
};

type TR<
  K extends keyof TriggerItemTypeRegistry = keyof TriggerItemTypeRegistry,
> = {
  [P in K]: TriggerManagerFn<P>;
};

const TriggerRegistry: TR = {
  TriggerAfterServerValidate: TriggersManager<'TriggerAfterServerValidate'>(),
  TriggerAfterUpload: TriggersManager<'TriggerAfterUpload'>(),
  TriggerAfterPaste: TriggersManager<'TriggerAfterPaste'>(),
  TriggerOnPaste: TriggersManager<'TriggerOnPaste'>(),
  TriggerOnDeleteKeyPress: TriggersManager<'TriggerOnDeleteKeyPress'>(),
  TriggerOnEnterKeyPress: TriggersManager<'TriggerOnEnterKeyPress'>(),
  TriggerOnRecordActive: TriggersManager<'TriggerOnRecordActive'>(),
  TriggerAfterDeleteRecord: TriggersManager<'TriggerAfterDeleteRecord'>(),
  TriggerBeforeDeleteRecord: TriggersManager<'TriggerBeforeDeleteRecord'>(),
  TriggerAfterInsertStoreRecord:
    TriggersManager<'TriggerAfterInsertStoreRecord'>(),
  TriggerBeforeInsertStoreRecord:
    TriggersManager<'TriggerBeforeInsertStoreRecord'>(),
  TriggerOnIconClick: TriggersManager<'TriggerOnIconClick'>(),
  TriggerOnTreeColumnExpand: TriggersManager<'TriggerOnTreeColumnExpand'>(),
  TriggerAfterLoad: TriggersManager<'TriggerAfterLoad'>(),
  TriggerAfterQuery: TriggersManager<'TriggerAfterQuery'>(),
  TriggerAfterSave: TriggersManager<'TriggerAfterSave'>(),
  TriggerBeforeCreate: TriggersManager<'TriggerBeforeCreate'>(),
  TriggerBeforeLoad: TriggersManager<'TriggerBeforeLoad'>(),
  TriggerBeforeQuery: TriggersManager<'TriggerBeforeQuery'>(),
  TriggerBeforeSave: TriggersManager<'TriggerBeforeSave'>(),
  TriggerOnAggregateClick: TriggersManager<'TriggerOnAggregateClick'>(),
  TriggerOnBlur: TriggersManager<'TriggerOnBlur'>(),
  TriggerOnCellClick: TriggersManager<'TriggerOnCellClick'>(),
  TriggerOnChange: TriggersManager<'TriggerOnChange'>(),
  TriggerOnClick: TriggersManager<'TriggerOnClick'>(),
  TriggerOnComment: TriggersManager<'TriggerOnComment'>(),
  TriggerOnCreate: TriggersManager<'TriggerOnCreate'>(),
  TriggerOnDelete: TriggersManager<'TriggerOnDelete'>(),
  TriggerOnDoubleClick: TriggersManager<'TriggerOnDoubleClick'>(),
  TriggerOnDrop: TriggersManager<'TriggerOnDrop'>(),
  TriggerOnDateChange: TriggersManager<'TriggerOnDateChange'>(),
  TriggerOnEventChange: TriggersManager<'TriggerOnEventChange'>(),
  TriggerOnEventClick: TriggersManager<'TriggerOnEventClick'>(),
  TriggerOnEventCreate: TriggersManager<'TriggerOnEventCreate'>(),
  TriggerOnExtraLargeScreen: TriggersManager<'TriggerOnExtraLargeScreen'>(),
  TriggerOnExtraSmallScreen: TriggersManager<'TriggerOnExtraSmallScreen'>(),
  TriggerOnFocus: TriggersManager<'TriggerOnFocus'>(),
  TriggerOnInitialize: TriggersManager<'TriggerOnInitialize'>(),
  TriggerOnInterval: TriggersManager<'TriggerOnInterval'>(),
  TriggerOnKeyDown: TriggersManager<'TriggerOnKeyDown'>(),
  TriggerOnLandscapeScreen: TriggersManager<'TriggerOnLandscapeScreen'>(),
  TriggerOnLargeScreen: TriggersManager<'TriggerOnLargeScreen'>(),
  TriggerOnMediumScreen: TriggersManager<'TriggerOnMediumScreen'>(),
  TriggerOnMention: TriggersManager<'TriggerOnMention'>(),
  TriggerOnMouseEnter: TriggersManager<'TriggerOnMouseEnter'>(),
  TriggerOnMouseLeave: TriggersManager<'TriggerOnMouseLeave'>(),
  TriggerOnPageActive: TriggersManager<'TriggerOnPageActive'>(),
  TriggerOnPageExit: TriggersManager<'TriggerOnPageExit'>(),
  TriggerOnPopoverClose: TriggersManager<'TriggerOnPopoverClose'>(),
  TriggerOnPopoverOpen: TriggersManager<'TriggerOnPopoverOpen'>(),
  TriggerOnPopupClose: TriggersManager<'TriggerOnPopupClose'>(),
  TriggerOnPopupOpen: TriggersManager<'TriggerOnPopupOpen'>(),
  TriggerOnPortraitScreen: TriggersManager<'TriggerOnPortraitScreen'>(),
  TriggerOnResponse: TriggersManager<'TriggerOnResponse'>(),
  TriggerOnRowClick: TriggersManager<'TriggerOnRowClick'>(),
  TriggerOnRowDoubleClick: TriggersManager<'TriggerOnRowDoubleClick'>(),
  TriggerOnSearch: TriggersManager<'TriggerOnSearch'>(),
  TriggerOnSmallScreen: TriggersManager<'TriggerOnSmallScreen'>(),
  TriggerOnSubmit: TriggersManager<'TriggerOnSubmit'>(),
  TriggerOnSubscriptionEvent: TriggersManager<'TriggerOnSubscriptionEvent'>(),
  TriggerOnTabActive: TriggersManager<'TriggerOnTabActive'>(),
  TriggerOnTabExit: TriggersManager<'TriggerOnTabExit'>(),
  TriggerOnValueChange: TriggersManager<'TriggerOnValueChange'>(),
  TriggerOnWindowSizeChange: TriggersManager<'TriggerOnWindowSizeChange'>(),
};

type CR<
  K extends keyof ComponentItemTypeRegistry = keyof ComponentItemTypeRegistry,
> = {
  [P in K]: ComponentManagerFn<P, any>;
};

/*
 * Make sure to sort when adding a new component. The components on the context menu
 * will be display in the same order in which it's listed here
 */
const ComponentRegistry: CR = {
  ChatBot: ChatBotManager,
  SparkLine: SparkLineManager,
  IFrame: IFrameManager,
  OrganizationChart: OrganizationChartManager,
  Tableau: TableauManager,
  Carousel: CarouselManager,
  GridPersonalizationMenu: GridPersonalizationMenuManager,
  AngularGauge: AngularGaugeManager,
  FusionMaps: FusionMapsManager,
  CombinationChartFC: CombinationChartFCManager,
  MultiSeriesChart: MultiSeriesChartManager,
  MultiDateSelector: MultiDateSelectorManager,
  CalendarSourceEvent: CalendarSourceEventManager,
  MutliSelectLOVField: MutliSelectLOVFieldManager,
  Accordion: AccordionManager,
  ActionButton: ActionButtonManager,
  ActionIconsColumn: ActionIconsColumnManager,
  ActiveUsers: ActiveUsersManager,
  Alert: AlertManager,
  Area: AreaManager,
  AreaToolbar: AreaToolbarManager,
  AreaToolbarEdit: AreaToolbarEditManager,
  AreaToolbarSave: AreaToolbarSaveManager,
  AreaToolbarUndoRedo: AreaToolbarUndoRedoManager,
  AreaToolbarZoom: AreaToolbarZoomManager,
  AsyncSelect: AsyncSelectManager,
  AsyncSelectColumn: AsyncSelectColumnManager,
  AttachmentColumn: AttachmentColumnManager,
  AttachmentField: AttachmentFieldManager,
  AttachmentRevisions: AttachmentRevisionsManager,
  AutoSizer: AutoSizerManager,
  Avatar: AvatarManager,
  AvatarList: AvatarListManager,
  Badge: BadgeManager,
  BingMap: BingMapManager,
  BingMapNavigator: BingMapNavigatorManager,
  Box: BoxManager as ComponentManagerFn<'Box'>,
  BoxContainer: BoxContainerManager,
  BoxList: BoxListManager as ComponentManagerFn<'BoxList'>,
  Breadcrumb: BreadcrumbManager,
  BreadcrumbItem: BreadcrumbItemManager,
  BreadcrumbNavigation: BreadcrumbNavigationManager,
  Button: ButtonManager,
  ButtonColumn: ButtonColumnManager,
  ButtonDropdown: ButtonDropdownManager,
  ButtonDropdownChild: ButtonDropdownChildManager,
  ButtonGroup: ButtonGroupManager,
  Calendar: CalendarManager,
  CalendarHeatmap: CalendarHeatmapManager,
  CanvasGrid: CanvasGridManager,
  Card: CardManager,
  CardActions: CardActionsManager,
  CardContent: CardContentManager,
  CardHeader: CardHeaderManager,
  ChartJSTooltip: ChartJSTooltipManager,
  ChartJSTreemap: ChartJSTreemapManager,
  Chartjs: ChartjsManager,
  Checkbox: CheckboxManager,
  CheckboxColumn: CheckboxColumnManager,
  CheckboxSearchField: CheckboxSearchFieldManager,
  Chip: ChipManager,
  Chips: ChipsManager,
  ClientSideExcelUpload: ClientSideExcelUploadManager,
  Clipboard: ClipboardManager,
  CloudDataStore: CloudDataStoreManager,
  Code: CodeManager,
  CollectionList: CollectionListManager,
  ColumnFooter: ColumnFooterManager,
  ColumnPanel: ColumnPanelManager,
  CombinationChart: CombinationChartManager,
  CommentActionMenuItems: CommentActionMenuItemsManager,
  Comments: CommentsManager,
  CommentsPanel: CommentsPanelManager,
  ControllerComponent: ControllerComponentManager,
  CustomTest: CustomTestManager,
  D3Chart: D3ChartManager,
  DarkModeToggle: DarkModeToggleManager,
  DataGrid: DataGridManager as ComponentManagerFn<'DataGrid', any>,
  DataList: DataListManager,
  DataStore: DataStoreManager,
  DataStoreReference: DataStoreReferenceManager,
  DateColumn: DateColumnManager,
  DateField: DateFieldManager,
  DateSearchField: DateSearchFieldManager,
  Device: DeviceManager,
  DiffChecker: DiffCheckerManager,
  DivColumn: DivColumnManager,
  Divider: DividerManager,
  DragSource: DragSourceManager,
  DragSourceBox: DragSourceBoxManager,
  Drawer: DrawerManager,
  DropTarget: DropTargetManager,
  DropTargetBox: DropTargetBoxManager,
  EmbedPage: EmbedPageManager,
  EmptySpacer: EmptySpacerManager,
  EndIcon: EndIconManager,
  EventSubscription: EventSubscriptionManager,
  ExcelViewer: ExcelViewerManager,
  ExpressionBuilderField: ExpressionBuilderFieldManager,
  ExpressionWatchListener: ExpressionWatchListenerManager,
  ExpressionWatcher: ExpressionWatcherManager,
  FAB: FABManager,
  FlexItem: FlexItemManager,
  FlexPanel: FlexPanelManager,
  FloatingPanel: FloatingPanelManager,
  Folder: FolderManager,
  Form: FormManager as ComponentManagerFn<'Form', any>,
  FormSearch: FormSearchManager,
  FormulaNumberColumn: FormulaNumberColumnManager,
  FormulaStringColumn: FormulaStringColumnManager,
  FullScreenToggle: FullScreenToggleManager,
  FunctionEditor: FunctionEditorManager,
  FusionChartsIO: FusionChartsIOManager,
  GoogleMap: GoogleMapManager,
  GraphicMessage: GraphicMessageManager,
  H1: H1Manager,
  H2: H2Manager,
  H3: H3Manager,
  H4: H4Manager,
  H5: H5Manager,
  H6: H6Manager,
  HTML: HTMLManager,
  HorizontalSplitPanel: HorizontalSplitPanelManager,
  IOSSwitch: IOSSwitchManager,
  Icon: IconManager,
  IconButton: IconButtonManager,
  IconCase: IconCaseManager,
  IconColumn: IconColumnManager,
  IconSelect: IconSelectManager,
  IconSwitch: IconSwitchManager,
  Image: ImageManager,
  ImageColumn: ImageColumnManager,
  InfoBox: InfoBoxManager,
  InputBase: InputBaseManager,
  Interval: IntervalManager,
  IoTImageMapper: IoTImageMapperManager,
  ImageCropper: ImageCropperManager,
  KanbanBoard: KanbanBoardManager,
  KanbanItem: KanbanItemManager,
  LOVColumn: LOVColumnManager,
  MultiSelectLOVColumn: MultiSelectLOVColumnManager,
  LOVField: LOVFieldManager,
  LOVGrid: LOVGridManager,
  LOVMap: LOVMapManager,
  LOVMappings: LOVMappingsManager,
  LanguageSelect: LanguageSelectManager,
  Link: LinkManager,
  LocalDataStore: LocalDataStoreManager,
  LookupSelect: LookupSelectManager,
  LookupSelectColumn: LookupSelectColumnManager,
  Markdown: MarkdownManager,
  Media: MediaManager,
  Menu: MenuManager,
  MenuItem: MenuItemManager,
  MenuItemDivider: MenuItemDividerManager,
  MenuItemList: MenuItemListManager,
  MetricBox: MetricBoxManager,
  MetricColorAndIcon: MetricColorAndIconManager,
  Mirror: MirrorManager,
  MultiField: MultiFieldManager,
  NumberColumn: NumberColumnManager,
  NumberField: NumberFieldManager,
  NumberSearchField: NumberSearchFieldManager,
  OCRComponent: OCRComponentManager,
  Page: PageManager,
  PageHeader: PageHeaderManager,
  PageMenu: PageMenuManager,
  Pagination: PaginationManager,
  Paper: PaperManager,
  PivotTable: PivotTableManager,
  PivotTableCalculatedColumn: PivotTableCalculatedColumnManager,
  PivotTableDateColumn: PivotTableDateColumnManager,
  PivotTableHiddenColumn: PivotTableHiddenColumnManager,
  PivotTableNumberColumn: PivotTableNumberColumnManager,
  PivotTableStringColumn: PivotTableStringColumnManager,
  Popover: PopoverManager,
  Popup: PopupManager,
  PopupActions: PopupActionsManager,
  PowerBI: PowerBIManager,
  ProgressIndicator: ProgressIndicatorManager,
  ProgressIndicatorColumn: ProgressIndicatorColumnManager,
  Pulse: PulseManager,
  PulseTip: PulseTipManager,
  RadioBox: RadioBoxManager,
  Rating: RatingManager,
  ReadOnlyDataStore: ReadOnlyDataStoreManager,
  RichTextEditor: RichTextEditorManager,
  RowAction: RowActionManager,
  RowNumberColumn: RowNumberColumnManager,
  RowPanel: RowPanelManager,
  RowSelectionColumn: RowSelectionColumnManager,
  SearchCheckbox: SearchCheckboxManager,
  SearchDateField: SearchDateFieldManager,
  SearchForm: SearchFormManager,
  SearchLookupField: SearchLookupFieldManager,
  SearchNumberField: SearchNumberFieldManager,
  SearchSelectField: SearchSelectFieldManager,
  SearchTextField: SearchTextFieldManager,
  Select: SelectManager,
  SelectColumn: SelectColumnManager,
  SelectReturnValueMapping: SelectReturnValueMappingManager,
  LookupReturnValueMapping: LookupReturnValueMappingManager,
  SelectSearchField: SelectSearchFieldManager,
  SidebarDraggableList: SidebarDraggableListManager,
  SidebarHeader: SidebarHeaderManager,
  SidebarList: SidebarListManager,
  SidebarListItem: SidebarListItemManager,
  SidebarNavLink: SidebarNavLinkManager,
  SidebarNavSection: SidebarNavSectionManager,
  SidebarNavDropdown: SidebarNavDropdownManager,
  SidebarPanel: SidebarPanelManager,
  SidebarSpacer: SidebarSpacerManager,
  SidebarNavList: SidebarNavListManager,
  SignaturePad: SignaturePadManager,
  SimpleFilter: SimpleFilterManager,
  SimpleFilterAttribute: SimpleFilterAttributeManager,
  SmartSearch: SmartSearchManager,
  SmartSearchAttribute: SmartSearchAttributeManager,
  SpeedDial: SpeedDialManager,
  SpeedDialAction: SpeedDialActionManager,
  StarColumn: StarColumnManager,
  StartIcon: StartIconManager,
  Step: StepManager,
  Stepper: StepperManager,
  StringColumn: StringColumnManager,
  SuspendPage: SuspendPageManager,
  SwitchColumn: SwitchColumnManager,
  SwitchColumnCase: SwitchColumnCaseManager,
  SwitchRole: SwitchRoleManager,
  TabItem: TabItemManager,
  TabPanel: TabPanelManager,
  Text: TextManager,
  TextField: TextFieldManager,
  TextSearchField: TextSearchFieldManager,
  Timeline: TimelineManager,
  TimelineConnector: TimelineConnectorManager,
  TimelineContent: TimelineContentManager,
  TimelineDot: TimelineDotManager,
  TimelineItem: TimelineItemManager,
  TimelineOppositeContent: TimelineOppositeContentManager,
  TimelineSeparator: TimelineSeparatorManager,
  Toolbar: ToolbarManager,
  ToolbarDivider: ToolbarDividerManager,
  ToolbarSpacer: ToolbarSpacerManager,
  Tracker: TrackerManager,
  Transaction: TransactionManager,
  TransactionMapping: TransactionMappingManager,
  TransientDataStore: TransientDataStoreManager,
  TreeColumn: TreeColumnManager,
  Typography: TypographyManager,
  UploadFileToFunction: UploadFileToFunctionManager,
  UserList: UserListManager,
  UserPic: UserPicManager,
  UserPicColumn: UserPicColumnManager,
  UserProfileMenu: UserProfileMenuManager,
  VerticalSplitPanel: VerticalSplitPanelManager,
  ViewAttachment: ViewAttachmentManager,
  WaveDots: WaveDotsManager,
  WorkflowViewer: WorkflowViewerManager,
};

export function registerAction(
  key: ActionItemType,
  action: (props: any) => Promise<boolean>,
): void {
  const mgr = getManager(key) as ActionManager<any>;
  mgr.action = action;
}

export function registerTrigger(
  key: TriggerItemType,
  trigger: (props: any) => Promise<boolean>,
): void {
  const mgr = getManager(key) as TriggerManager<any>;
  mgr.trigger = trigger;
}

export function registerComponents(
  key: ComponentItemType,
  Component: React.FunctionComponent<any>,
  DEVComponent?: React.FunctionComponent<any>,
): void {
  const mgr = getManager(key) as ComponentManager<any>;
  mgr.Component = Component;
  mgr.DEVComponent = DEVComponent;
}

const ComponentKeys = Object.keys(ComponentRegistry) as ComponentItemType[];
const TriggerKeys = Object.keys(
  TriggerRegistry,
) as (keyof typeof TriggerRegistry)[];
const ActionKeys = Object.keys(ActionRegistry) as ActionItemType[];

let initialized = false;
const testComponents: ItemType[] = [];
// @ts-ignore lazy initializer

const init = (platform: Platform, force = false) => {
  if (initialized && !force) {
    return;
  }
  // console.info('Initializing components...');
  (Object.keys(ComponentRegistry) as ComponentItemType[]).forEach((key) => {
    const mgrFn = ComponentRegistry[key];
    const mgr = mgrFn(platform, key as never);
    registerManager(key, mgr);
    if (mgr.managerType === 'Component') {
      testComponents.push(key);
    }
  });
  (Object.keys(ActionRegistry) as ActionItemType[]).forEach((key) => {
    const mgrFn = ActionRegistry[key];
    const mgr = mgrFn(platform);
    registerManager(key, mgr);
  });
  (Object.keys(TriggerRegistry) as (keyof typeof TriggerRegistry)[]).forEach(
    (key) => {
      const mgrFn = TriggerRegistry[key];
      const mgr = mgrFn(platform, key as never);
      registerManager(key, mgr);
    },
  );

  initialized = true;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hmrReplace = <T extends ItemType>(
  key: T,
  mgrFn: AnyManagerFn,
): AnyManager | undefined => {
  let oldMgr: AnyManager;
  try {
    oldMgr = getManager(key) as AnyManager;
  } catch (error) {
    return;
  }
  if (oldMgr) {
    const mgr = mgrFn(oldMgr.platform, key);
    if (oldMgr.managerType === 'Component' && mgr.managerType === 'Component') {
      mgr.Component = oldMgr.Component;
      mgr.DEVComponent = oldMgr.DEVComponent;
    }
    registerManager(key, mgr);
    return mgr;
  }
};

// const x: ItemType = 'Button';

// type A = typeof Components[typeof x]['defaultValue'];

// export type ItemProps<
//   T extends ItemType
// > = typeof Components[T]['defaultValue'];

const getMgr = <K extends ComponentItemType>(
  type: K,
): ComponentManagerFn<K, any> => {
  return ComponentRegistry[type] as unknown as ComponentManagerFn<K, any>;
};
